import { mapGetters } from 'vuex'
import axios from 'axios'
import Vue from 'vue'

import is from '../web/plugins/helper/is'
import { listen } from '../web/plugins/event/listen'

let timeEndsEventFiles = null
let timeCargaArchivo = null
let timeEsperarTamanioArchivos = null

/**
 * Servicio exclusivo del Módulo de Venta y Trámite
 */
const helperMixin = {
  computed: {
    getJobStabilityCounter: function () {
      let stability = 2
      const stabilities = []
      while (stability <= 23) {
        stabilities.push({ value: stability.toString(), text: `${stability} meses` })
        stability++
      }

      return stabilities
    },
    checkPreContractModel: function () {
      if (
        this.precontract &&
        this.precontract.modelo &&
        this.precontract.proyecto &&
        this.checkVariable(this.precontract, this.precontract.modelo, this.precontract.proyecto)
      ) {
        return true
      }

      return false
    },
    checkCustomerVisibility: function () {
      if (!this.checkVariable(this.precontract)) {
        return false
      }

      return this.getBoolValue(this.precontract.visibilidad) === true
    },
    sleepingOptionClient: function () {
      const tem = []
      let index = 6
      while (index < 24) {
        tem[index] = `dormir hasta cuando tiene ${index} meses`
        index++
      }

      return [...tem, 'dormir hasta cuando tiene 24 o mas meses']
    },
    aniosEntrega: function () {
      const anios = []
      let anio = new Date().getFullYear() + 1
      const max = 5
      for (let index = anio; index < anio + max; index++) {
        anios.push(index)
      }

      return anios
    },
    ...mapGetters({
      loadingNotifyRoomChange: 'loadingNotifyRoomChange',
      loadingRegisterSubscriptionConversation: 'loadingRegisterSubscriptionConversation',
    }),
  },
  methods: {
    massSaleConfirmationMessage({ trigger, title, text, input, html, inputPlaceholder, inputAttributes, confirmButtonText, inputValidator, column }, idMarked) {
      let form = this.createAdvancedFilter(this.filterable.url)
      if (this.isObject(form) && this.getAmountOfKeys(idMarked) > 0) {
        const arrVal = []
        Object.keys(idMarked).forEach(key => {
          if (this.checkVariable(idMarked[key])) {
            arrVal.push(idMarked[key])
          }
        })
        form['id_marked'] = arrVal
      }

      this.defaultSettingsSwal()
      const swal = this.setupSwal()

      return swal.fire({
        title,
        text,
        html,
        input,
        inputPlaceholder,
        inputAttributes,
        inputValidator,
        confirmButtonText,
        showCancelButton: true,
        preConfirm: value => {
          let message = undefined
          if (this.checkVariable(column, value) && column === 'message' && this.getLastIndexOf(value, '.') === -1) {
            message = `${value}.`
          } else if (this.checkVariable(column, value) && column === 'message' && this.getLastIndexOf(value, '.') !== -1) {
            message = value
          }

          const request = {}
          if (!this.checkVariable(html) && this.checkVariable(column, value)) {
            request[column] = this.isUndefined(message) ? value : message
          }

          if (this.checkVariable(html) && is.node(html)) {
            const numeroEnvio = is.getNodeWith(html, 'input[name="numero_plantilla_feria_convivienda"]:checked')
            const archivoEnviar = is.getNodeWith(html, 'input[name="archivo_a_enviar"]')
            const forzarEnvio = is.getNodeWith(html, 'input[name="forzar_envio_sin_cola"]')
            const forzarEnvioTramitador = is.getNodeWith(html, 'input[name="forzar_envio_todas_forma"]')
            const nodes = is.getNodeWithAll(html, 'input[name="redirigir_a"]:checked,textarea,select')
            if (is.nodeList(nodes)) {
              nodes.forEach(node => {
                const newValue = node.value
                let message = undefined
                const name = is.getUniqueAttribute(node, 'name')
                if (name === 'message' && this.getLastIndexOf(newValue, '.') === -1 && !is.node(archivoEnviar)) {
                  message = `${newValue}.`
                } else if (name === 'message' && this.getLastIndexOf(newValue, '.') !== -1 && !is.node(archivoEnviar)) {
                  message = newValue
                } else {
                  message = newValue
                }
                request[is.getUniqueAttribute(node, 'name')] = message
              })
            }
            if (is.node(archivoEnviar)) {
              const file = this.checkVariable(archivoEnviar) && this.checkVariable(archivoEnviar.files) && !this.isUndefined(archivoEnviar.files[0]) ? archivoEnviar.files[0] : archivoEnviar
              request[is.getUniqueAttribute(archivoEnviar, 'name')] = file
            }
            if (is.node(forzarEnvio)) {
              request[is.getUniqueAttribute(forzarEnvio, 'name')] = forzarEnvio.checked === true ? 1 : 0
            }
            if (is.node(forzarEnvioTramitador)) {
              request[is.getUniqueAttribute(forzarEnvioTramitador, 'name')] = forzarEnvioTramitador.checked === true ? 1 : 0
            }
            if (is.node(numeroEnvio)) {
              request[is.getUniqueAttribute(numeroEnvio, 'name')] = numeroEnvio.value
            }
          }

          form = this.objectToFormData({ ...form, ...request })

          return axios.post(trigger.value, form)
        },
      }).then(response => {
        trigger.value = ''
        if (this.checkVariable(response) && this.checkVariable(response.isConfirmed) && response.isConfirmed) {
          this.defaultSettingsToastSwal()
          this.swalTitle = this.$t('massive_has_been_queued')
          this.swalText = undefined
          this.positionedDialogToast()
          this.$store.dispatch('setUpdateStatus', this.generateRandomNumber(10))
          this.$store.commit('SET_GLOBAL_CHECK_ACTION', [])
        }

        return response
      })
    },
    massiveSharesSales({ trigger, title, text, input, inputPlaceholder, inputAttributes, confirmButtonText, column }, idMarked) {
      const form = this.createAdvancedFilter(this.filterable.url)
      if (this.isObject(form) && this.getAmountOfKeys(idMarked) > 0) {
        const arrVal = []
        Object.keys(idMarked).forEach(key => {
          if (this.checkVariable(idMarked[key])) {
            arrVal.push(idMarked[key])
          }
        })
        form['id_marked'] = arrVal
      }

      this.defaultSettingsSwal()
      const swal = this.setupSwal()

      return swal.fire({
        title,
        text,
        input,
        inputPlaceholder,
        inputAttributes,
        confirmButtonText,
        showCancelButton: true,
        preConfirm: value => {
          if (this.checkVariable(column, value)) {
            form[column] = value
          }

          return axios.post(trigger.value, form).catch(e => {
            trigger.value = ''

            return e
          })
        },
      }).then(response => {
        trigger.value = ''
        if (this.checkVariable(response) && this.checkVariable(response.isConfirmed) && response.isConfirmed) {
          this.defaultSettingsToastSwal()
          this.swalTitle = this.$t('massive_has_been_queued')
          this.swalText = undefined
          this.positionedDialogToast()
          this.$store.dispatch('setUpdateStatus', this.generateRandomNumber(10))
          this.$store.commit('SET_GLOBAL_CHECK_ACTION', [])
        }

        return response
      })
    },
    performVariousSalesAction({ url, title, text, input, inputPlaceholder, inputAttributes, inputValue, confirmButtonText, column }, dataToRevert = null, messageToRevert = null, urlToRevert = null) {
      if (!this.checkVariable(url)) {
        return false
      }

      this.defaultSettingsSwal()
      const swal = this.setupSwal()

      return swal.fire({
        title,
        text,
        input,
        inputValue,
        inputPlaceholder,
        inputAttributes,
        confirmButtonText,
        showCancelButton: true,
        showConfirmButton: true,
        preConfirm: value => {
          const request = {}
          if (this.checkVariable(column, value)) {
            request[column] = value
          }
          if (this.checkVariable(dataToRevert) && this.checkVariable(messageToRevert) && this.checkVariable(urlToRevert)) {
            this.captureDataToRevert('asign_sales', dataToRevert, messageToRevert, urlToRevert)
          }

          return axios.post(url, request)
        },
      }).then(response => {
        if (this.checkVariable(response) && this.checkVariable(response.isConfirmed) && response.isConfirmed) {
          this.defaultSettingsToastSwal()
          this.swalTitle = this.$t('update_response')
          this.swalText = undefined
          this.positionedDialogToast()
          this.$store.dispatch('setUpdateStatus', this.generateRandomNumber(10))

          if (this.checkVariable(dataToRevert) && this.checkVariable(messageToRevert) && this.checkVariable(urlToRevert)) {
            this.$root.$emit('triggerSwitchRevertDataToast', true)
          }
        }

        return response
      })
    },
    attachSalesDocumentsAction({ url, title, confirmButtonText }, dataToRevert = null, messageToRevert = null, alternativeUrlToRevert = null) {
      this.defaultSettingsSwal()
      const swal = this.setupSwal()

      return swal.fire({
        title,
        input: 'file',
        confirmButtonText,
        showCancelButton: true,
        showConfirmButton: true,
        inputValidator: (value) => {
          if (this.checkVariable(value) && value.size > 20000000) {
            return 'El archivo no puede ser mayor de 20 MB.'
          }
        },
        preConfirm: file => {
          const form = is.objectToFormData({ file })
          this.captureDataToRevert('asign_sales', dataToRevert, messageToRevert, alternativeUrlToRevert)

          return axios.post(url, form)
        },
      }).then(response => {
        if (this.checkVariable(response) && this.checkVariable(response.isConfirmed) && response.isConfirmed) {
          this.defaultSettingsToastSwal()
          this.swalTitle = this.$t('update_response')
          this.swalText = undefined
          this.positionedDialogToast()
          this.$root.$emit('triggerSwitchRevertDataToast', true)
          this.$store.dispatch('setUpdateStatus', this.generateRandomNumber(10))
        }

        return response
      })
    },
    confirmationMessageWhatsappSale({ trigger, title, text, confirmButtonText, input, inputPlaceholder, inputAttributes, inputValidator, html, column }) {
      this.defaultSettingsSwal()
      const swal = this.setupSwal()

      return swal.fire({
        title,
        text,
        html,
        input,
        inputPlaceholder,
        inputAttributes,
        confirmButtonText,
        inputValidator,
        showCancelButton: true,
        preConfirm: value => {
          let message = undefined
          if (this.checkVariable(column, value) && column === 'message' && this.getLastIndexOf(value, '.') === -1) {
            message = `${value}.`
          } else if (this.checkVariable(column, value) && column === 'message' && this.getLastIndexOf(value, '.') !== -1) {
            message = value
          }

          const request = {}
          if (!this.checkVariable(html) && this.checkVariable(column, value)) {
            request[column] = this.isUndefined(message) ? value : message
          }
          if (this.checkVariable(html) && is.node(html)) {
            const nodes = is.getNodeWithAll(html, 'input,textarea')
            if (is.nodeList(nodes)) {
              nodes.forEach(node => {
                const newValue = node.value
                let message = undefined
                const name = is.getUniqueAttribute(node, 'name')
                if (name === 'message' && this.getLastIndexOf(newValue, '.') === -1) {
                  message = `${newValue}.`
                } else if (name === 'message' && this.getLastIndexOf(newValue, '.') !== -1) {
                  message = newValue
                } else {
                  message = newValue
                }
                request[is.getUniqueAttribute(node, 'name')] = message
              })
            }
          }

          const form = this.objectToFormData(request)

          return axios.post(trigger.value, form)
        },
      }).then(response => {
        trigger.value = ''
        if (this.checkVariable(response) && this.checkVariable(response.isConfirmed) && response.isConfirmed) {
          const { value } = response
          const { data, config } = value
          const urlAction = this.checkVariable(config) ? config.url : null
          const persona = this.checkVariable(data.personas) ? data.personas : null
          const user = this.authUser
          const ignoreOptionsPerRoute = []
          const result = this.findWith(ignoreOptionsPerRoute, (val) => {
            return (urlAction && this.regExpTest(`${val}\\b`, urlAction) === true)
          })
          if (user && user.con_funcionalidad_conversacion === true && result === -1) {
            this.defaultSettingsToastSwal()
            this.swalTitle = this.$t('update_response')
            this.swalText = undefined
            this.positionedDialogToast()
            this.$store.dispatch('setUpdateStatus', this.generateRandomNumber(10))

            return response
          }
          if (!this.checkVariable(persona) || !this.checkVariable(persona.celular)) {
            return response
          }
          if (this.checkVariable(data) && this.checkVariable(config) && this.checkVariable(persona.precontrato_id)) {
            /** @var FormData */
            const form = config.data
            const phone = /^(507)/.test(persona.celular) ? persona.celular : `507${persona.celular}`

            /** @var String */
            let apiUrl = ''
            if (this.regExpTest('enviar_para_firma_contrato_whatsapp\\b', urlAction) === true) {
              const token = data.notificar_firma_contrato_digital_cliente_codigo
              apiUrl = `${is.getValueSetting('appUrl')}/clientes/precontrato/verificar_notificacion_firma_contrato_digital/${token}`
            } else if (this.regExpTest('enviar_para_completar_datos_whatsapp\\b', urlAction) === true) {
              const token = data.notificar_completar_datos_cliente_codigo
              apiUrl = `${is.getValueSetting('appUrl')}/clientes/precontrato/verificar_completar_datos/${token}`
            } else if (this.regExpTest('enviar_formulario_bancario_whatsapp\\b', urlAction) === true) {
              const token = data.notificar_datos_bancarios_cliente_codigo
              apiUrl = `${is.getValueSetting('appUrl')}/formularios/verificar_datos_bancarios/${token}`
            } else if (this.regExpTest('enviar_para_completar_estatus_laboral\\b', urlAction) === true) {
              const token = data.notificar_completar_estatus_laboral_cliente_codigo
              apiUrl = `${is.getValueSetting('appUrl')}/clientes/precontrato/verificar_completar_estatus_laboral/${token}`
            } else if (this.regExpTest('enviar_para_firmar_adenda_whatsapp\\b', urlAction) === true) {
              const token = data.notificar_firma_adenda_cliente_codigo
              apiUrl = `${is.getValueSetting('appUrl')}/clientes/precontrato/verificar_firmar_adenda/${token}`
            } else if (this.regExpTest('enviar_para_firmar_declaracion_jurada_mivi_whatsapp\\b', urlAction) === true) {
              const token = data.notificar_firma_declaracion_jurada_mivi_codigo
              apiUrl = `${is.getValueSetting('appUrl')}/clientes/precontrato/verificar_firmar_declaracion_jurada_mivi/${token}`
            } else if (this.regExpTest('enviar_para_completar_grupo_familiar_whatsapp\\b', urlAction) === true) {
              const token = data.notificar_completar_grupo_familiar_cliente_codigo
              apiUrl = `${is.getValueSetting('appUrl')}/clientes/precontrato/verificar_completar_grupo_familiar/${token}`
            } else if (this.regExpTest('enviar_para_firmar_autorizacion_apc_banco_nacional_whatsapp\\b', urlAction) === true) {
              const token = data.notificar_firmar_autorizacion_apc_banco_nacional_codigo
              apiUrl = `${is.getValueSetting('appUrl')}/clientes/precontrato/verificar_firmar_autorizacion_apc_banco_nacional/${token}`
            } else if (this.regExpTest('enviar_para_firmar_autorizacion_apc_la_hipotecaria_whatsapp\\b', urlAction) === true) {
              const token = data.notificar_firmar_autorizacion_apc_la_hipotecaria_codigo
              apiUrl = `${is.getValueSetting('appUrl')}/clientes/precontrato/verificar_firmar_autorizacion_apc_la_hipotecaria/${token}`
            } else if (this.regExpTest('enviar_para_firmar_autorizacion_apc_la_caja_de_ahorro_whatsapp\\b', urlAction) === true) {
              const token = data.notificar_firmar_autorizacion_apc_caja_de_ahorro_codigo
              apiUrl = `${is.getValueSetting('appUrl')}/clientes/precontrato/verificar_firmar_autorizacion_apc_la_caja_de_ahorro/${token}`
            }

            const message = form.get('message')
            const text = this.checkVariable(message) ? `${message} ${apiUrl}` : apiUrl
            const newParams = this.createTheParametersOfTheUrl({
              phone,
              ...is.checkVariable(form) && form instanceof FormData && this.checkVariable(text) ? { text } : '',
            })
            window.open(`https://api.whatsapp.com/send${newParams}`, '_blank')
          }

          this.defaultSettingsToastSwal()
          this.swalTitle = this.$t('update_response')
          this.swalText = undefined
          this.positionedDialogToast()
          this.$store.dispatch('setUpdateStatus', this.generateRandomNumber(10))
        }

        return response
      })
    },
    deleteSale(model, url, indexColumn = 'id', alternativeUrl = null, otherText = null) {
      const promise = this.actionDeleteFile(url, model[indexColumn], 'delete_sales', alternativeUrl, otherText)
      this.actionDeleteThen(promise)
    },
    changeOfSaleStatus(url, id, columns, message, urlToRevert) {
      this.defaultSettingsSwal()
      const swal = this.setupSwal()

      return swal.fire({
        input: 'textarea',
        inputPlaceholder: 'Agrega un comentario',
        inputAttributes: {
          'aria-label': 'Escribe tu mensaje aquí',
        },
        showCancelButton: true,
        preConfirm: value => {
          const form = this.objectToFormData({ descripcion: value })
          this.captureDataToRevert('asign_sales', [{ id, columns }], message, urlToRevert)

          return axios.post(url, form)
        },
      }).then(response => {
        if (this.checkVariable(response) && this.checkVariable(response.isConfirmed) && response.isConfirmed) {
          this.defaultSettingsToastSwal()
          this.swalTitle = this.$t('update_response')
          this.swalText = undefined
          this.positionedDialogToast()
          this.$root.$emit('triggerSwitchRevertDataToast', true)
          this.$store.dispatch('setUpdateStatus', this.generateRandomNumber(10))
        }

        return response
      })
    },
    selectionEmailSaleEvent(event, idMarked) {
      const trigger = event.target
      if (this.checkVariable(trigger.value)) {
        let title = {}
        if (this.regExpTest('enviar_email_masivo_firma\\b', trigger.value) === true) {
          title = { title: 'Masivo para Firma de Contrato', text: '' }
        } else if (this.regExpTest('enviar_email_masivo_completar\\b', trigger.value) === true) {
          title = { title: 'Masivo para Completar Datos/Requisitos', text: '' }
        } else if (this.regExpTest('enviar_formulario_bancario_masivo_email\\b', trigger.value) === true) {
          title = { title: 'Masivo para Completar Formulario Bancario', text: '' }
        } else if (this.regExpTest('enviar_email_masivo_para_firmar_adenda\\b', trigger.value) === true) {
          if (this.determinesInspectionAction(['changeFinalPriceAddendum']) === true) {
            title = {
              title: 'Masivo para Firma de Adenda',
              text: '',
              input: 'number',
              inputPlaceholder: 'Precio venta',
              inputAttributes: {
                step: 'any',
                autocapitalize: 'off',
              },
              column: 'precio_final_adenda',
            }
          } else {
            title = { title: 'Masivo para Firma de Adenda', text: '' }
          }
        } else if (this.regExpTest('enviar_email_formulario_nuevo_cliente\\b', trigger.value) === true) {
          return this.sendNewCostumerFormEmailSale(event)
        } else if (this.regExpTest('envio_masivo_proforma\\b', trigger.value) === true) {
          title = {
            title: 'Envío Masivo de la Proforma',
            text: '',
            input: 'textarea',
            inputPlaceholder: 'Agregar un comentario',
            inputAttributes: {
              step: 'any',
              autocapitalize: 'off',
            },
            column: 'message',
          }
        } else if (this.regExpTest('mensaje_masivo_email\\b', trigger.value) === true) {
          title = {
            title: 'Mensaje masivo',
            text: '',
            input: 'textarea',
            inputPlaceholder: 'Agregar un comentario',
            inputAttributes: {
              step: 'any',
              autocapitalize: 'off',
            },
            column: 'message',
          }
        } else if (this.regExpTest('enviar_email_masivo_suscribirse_notificaciones_navegador\\b', trigger.value) === true) {
          title = { title: 'Correo para Suscribir a notificaciones del navegador', text: '' }
        }

        return this.massiveSharesSales(
          {
            trigger,
            ...title,
            confirmButtonText: 'Enviar',
          },
          idMarked,
        )
      }
    },
    independentSelectionEmailSaleEvent(event) {
      const trigger = event.target
      if (this.precontract && !this.checkVariable(this.precontract.imagen_firma_cedula_uri)) {
        this.defaultSettingsSwal()
        this.swalTitle = undefined
        this.swalText = `Antes de enviar la adenda al cliente, asegúrate de que haya creado su firma digital, ya que la adenda solo puede ser refrendada de forma digital.

        Si el cliente no desea firmar digitalmente o no puede hacerlo, deberás exportar la adenda y enviársela por este chat en PDF para que él la descargue, la firme manualmente y te la reenvíe firmada por este mismo medio.`
        this.positionedDialogToast()
        this.$store.dispatch('setUpdateStatus', this.generateRandomNumber(10))

        return false
      }

      if (this.checkVariable(trigger.value)) {
        let title = {}
        if (this.regExpTest('enviar_para_firma_contrato\\b', trigger.value) === true) {
          title = { title: 'Correo para Firma de Contrato', text: '' }
        } else if (this.regExpTest('enviar_para_completar_datos\\b', trigger.value) === true) {
          title = { title: 'Correo para Completar Datos/Requisitos', text: '' }
        } else if (this.regExpTest('enviar_formulario_bancario_email\\b', trigger.value) === true) {
          title = { title: 'Correo para Completar Formulario Bancario', text: '' }
        } else if (this.regExpTest('enviar_datos_del_cliente_al_banco\\b', trigger.value) === true) {
          title = { title: 'Envio de Documentos al Banco', text: '' }
        } else if (this.regExpTest('enviar_para_firmar_adenda\\b', trigger.value) === true) {
          if (this.determinesInspectionAction(['changeFinalPriceAddendum']) === true) {
            let finalPrice = 0
            if (!this.checkVariable(this.precontract.precio_final_adenda) && this.precontract.precio_final > 0) {
              finalPrice = this.precontract.precio_final
            } else if (this.checkVariable(this.precontract.precio_final_adenda) && this.precontract.precio_final_adenda > 0) {
              finalPrice = this.precontract.precio_final_adenda
            }
            title = {
              title: 'Correo para Firma de Adenda',
              text: '',
              input: 'number',
              inputPlaceholder: 'Precio venta',
              inputAttributes: {
                step: 'any',
                autocapitalize: 'off',
              },
              inputValue: finalPrice,
              column: 'precio_final_adenda',
            }
          } else {
            title = {
              title: 'Correo para Firma de Adenda',
              text: '',
            }
          }
        } else if (this.regExpTest('enviar_contrato_y_adenda_al_banco\\b', trigger.value) === true) {
          title = { title: 'Envio de Contrato y Adenda al Banco', text: '' }
        } else if (this.regExpTest('enviar_email_suscribirse_notificaciones_navegador\\b', trigger.value) === true) {
          title = { title: 'Correo para Suscribirse a notificaciones del navegador', text: '' }
        } else if (this.regExpTest('enviar_email_para_firma_declaracion_jurada_mivi\\b', trigger.value) === true) {
          title = { title: 'Enviar Declaracion Jurada MIVI al cliente', text: '' }

          return this.checkAndSendForSignMIVISwornDeclaration('email', trigger, title)
        } else if (this.regExpTest('enviar_email_paquete_mivi\\b', trigger.value) === true) {
          return this.checkAndSendEmailPackageMIVI(trigger.value)
        } else if (this.regExpTest('enviar_email_solicitud_impuestos\\b', trigger.value) === true) {
          return this.sendTaxesRequest(trigger.value)
        } else if (this.regExpTest('enviar_email_paquete_al_cliente\\b', trigger.value) === true) {
          return this.checkForSendCostumerPackage()
        } else if (this.regExpTest('enviar_para_completar_grupo_familiar\\b', trigger.value) === true) {
          title = { title: 'Correo para Completar información de Grupo Familiar e Ingresos Familiares', text: '' }
        } else if (this.regExpTest('enviar_para_firmar_autorizacion_apc_banco_nacional_email\\b', trigger.value) === true) {
          title = { title: 'Enviar Autorización APC del Banco Nacional al cliente', text: '' }
        } else if (this.regExpTest('enviar_para_firmar_autorizacion_apc_la_hipotecaria_email\\b', trigger.value) === true) {
          title = { title: 'Enviar Autorización APC del Banco La Hipotecaria al cliente', text: '' }
        } else if (this.regExpTest('enviar_para_firmar_autorizacion_apc_la_caja_de_ahorro_email\\b', trigger.value) === true) {
          title = { title: 'Enviar Autorización APC del Banco La Caja de ahorro al cliente', text: '' }
        }

        return this.performVariousSalesAction({
          url: trigger.value,
          ...title,
          confirmButtonText: 'Enviar',
        })
      }
    },
    async selectionWhatsappSaleEvent(event, idMarked) {
      const trigger = event.target
      let title = {}
      if (!this.checkVariable(trigger.value)) {
        return null
      }

      const formMasivoSimilares = is.make('form', {}, [
        is.make('div', { 'class': 'form-group' }, [
          is.make('label', { 'for': 'forzar_envio_sin_cola' }, [
            is.text('Forzar envío'),
          ]),
          is.make('input', { 'type': 'checkbox', 'class': 'form-control', 'name': 'forzar_envio_sin_cola', 'value': '1' }),
        ]),
        is.make('div', { 'class': 'form-group' }, [
          is.make('label', { 'for': 'forzar_envio_todas_forma' }, [
            is.text('Enviar de todas forma si el tramitador no lo permite'),
          ]),
          is.make('input', { 'type': 'checkbox', 'class': 'form-control', 'name': 'forzar_envio_todas_forma', 'value': '1' }),
        ]),
      ])
      if (this.regExpTest('enviar_whatsapp_masivo_firma\\b', trigger.value) === true) {
        title = { title: 'Masivo para firma contrato', text: '' }
      } else if (this.regExpTest('enviar_whatsapp_masivo_completar\\b', trigger.value) === true) {
        title = { title: 'Masivo para completar Datos/Requisitos', text: '' }
      } else if (this.regExpTest('enviar_formulario_bancario_masivo_whatsapp\\b', trigger.value)) {
        title = { title: 'Masivo para completar Formulario Bancario', text: '' }
      } else if (this.regExpTest('enviar_whatsapp_masivo_proyecto_ph_mirador_apartamento_phm\\b', trigger.value)) {
        title = { title: 'Masivo de avance del modelo PH Mirador Apartamento PHM', text: '' }
      }  else if (this.regExpTest('enviar_whatsapp_masivo_cambiar_modelo_gold_mendozas_park\\b', trigger.value)) {
        title = { title: 'Notificación cambiar al modelo Gold de Mendozas Park', text: '' }
      } else if (this.regExpTest('mensaje_masivo_whatsapp\\b', trigger.value) === true) {
        const { data } = await axios.post(`${this.filterable.url}/twilio_registered_templates`)
        data.unshift({ '': '--SELECCIONAR--'})
        const form = is.make('form', {}, [
          is.make('div', { 'class': 'form-group' }, [is.make('textarea', { 'rows': 10, 'cols': 50, 'class': 'form-control', 'name': 'message', 'id': 'swal2-whats-app-message', placeholder: 'Mensaje' })]),
          is.make('div', { 'class': 'form-group' }, [
            is.make('label', { 'for': 'archivo_a_enviar' }, [
              is.text('Archivo'),
            ]),
            is.make('input', { 'type': 'file', 'class': 'form-control', 'name': 'archivo_a_enviar', 'id': 'archivo_a_enviar' }),
          ]),
          is.make('div', { 'class': 'form-group' }, [
            is.make('label', { 'for': 'forzar_envio_sin_cola' }, [
              is.text('Forzar envío'),
            ]),
            is.make('input', { 'type': 'checkbox', 'class': 'form-control', 'name': 'forzar_envio_sin_cola', 'value': '1' }),
          ]),
          is.make('div', { 'class': 'form-group' }, [
            is.make('label', { 'for': 'forzar_envio_todas_forma' }, [
              is.text('Enviar de todas forma si el tramitador no lo permite'),
            ]),
            is.make('input', { 'type': 'checkbox', 'class': 'form-control', 'name': 'forzar_envio_todas_forma', 'value': '1' }),
          ]),
          is.make('div', { 'class': 'form-group' }, [
            is.make('label', { 'for': 'seleccion_plantilla_masivos' }, [
              is.text('Plantilla redirigir'),
            ]),
            is.select(data, { 'class': 'form-control', 'name': 'seleccion_plantilla_masivos', 'id': 'seleccion_plantilla_masivos' }),
          ]),
        ])
        title = {
          title: 'Mensaje personalizado',
          html: form,
        }
      } else if (this.regExpTest('enviar_whatsapp_masivo_completar_estatus_laboral\\b', trigger.value) === true) {
        title = { title: 'Masivo para completar Estatus Laboral', text: '' }
      } else if (this.regExpTest('enviar_whatsapp_masivo_para_firmar_adenda\\b', trigger.value) === true) {
        if (this.determinesInspectionAction(['changeFinalPriceAddendum']) === true) {
          title = {
            title: 'Masivo para Firma de Adenda',
            text: '',
            input: 'number',
            inputPlaceholder: 'Precio venta',
            inputAttributes: {
              step: 'any',
              autocapitalize: 'off',
            },
            column: 'precio_final_adenda',
          }
        } else {
          title = { title: 'Masivo para Firma de Adenda', text: '' }
        }
      } else if (this.regExpTest('enviar_whastapp_formulario_nuevo_cliente\\b', trigger.value) === true) {
        return this.sendNewCostumerFormWhatsappSale(event)
      } else if (this.regExpTest('enviar_whatsapp_masivo_solicitud_requerimientos_hipoteca\\b', trigger.value) === true) {
        title = {
          title: 'Masivo para solicitar Requerimientos de Hipoteca',
          html: formMasivoSimilares,
        }
      } else if (this.regExpTest('enviar_whatsapp_masivo_solicitud_firmar_o_adjuntar_autorizacion_apc\\b', trigger.value) === true) {
        title = {
          title: 'Masivo para solicitar para Firmar o Adjuntar Autorización APC',
          html: formMasivoSimilares,
        }
      } else if (this.regExpTest('enviar_whatsapp_masivo_solicitud_firmar_o_adjuntar_contrato_promesa\\b', trigger.value) === true) {
        title = {
          title: 'Masivo para solicitar para Firmar o Adjuntar Contrato de Promesa',
          html: formMasivoSimilares,
        }
      } else if (this.regExpTest('enviar_whatsapp_masivo_solicitud_llenar_formulario_hipotecario\\b', trigger.value) === true) {
        title = {
          title: 'Masivo para solicitar para Llenar Formulario Hipotecario',
          html: formMasivoSimilares,
        }
      } else if (this.regExpTest('enviar_whatsapp_masivo_hablar_con_agente_asignado\\b', trigger.value) === true) {
        title = {
          title: 'Masivo para notificación hablar con agente asignado',
          html: formMasivoSimilares,
        }
      } else if (this.regExpTest('enviar_whatsapp_masivo_conversar_con_agente_asignado\\b', trigger.value) === true) {
        title = {
          title: 'Masivo para notificación conversar en completo365\nÚnicamente para clientes con conversación en completo.',
          html: formMasivoSimilares,
        }
      } else if (this.regExpTest('enviar_whatsapp_masivo_feria_convivienda\\b', trigger.value) === true) {
        title = {
          title: 'Notificación feria 24-08-02 convivienda.',
          html: is.make('form', {}, [
            is.make('div', { 'class': 'form-group' }, [
              is.make('label', { 'for': 'forzar_envio_sin_cola' }, [
                is.text('Forzar envío'),
              ]),
              is.make('input', { 'type': 'checkbox', 'class': 'form-control', 'name': 'forzar_envio_sin_cola', 'value': '1' }),
            ]),
            is.make('div', { 'class': 'form-group' }, [
              is.make('label', { 'for': 'forzar_envio_todas_forma' }, [
                is.text('Enviar de todas forma si el tramitador no lo permite'),
              ]),
              is.make('input', { 'type': 'checkbox', 'class': 'form-control', 'name': 'forzar_envio_todas_forma', 'value': '1' }),
            ]),
            is.make('div', { 'class': 'table-responsive' }, [
              is.make('table', { 'class': 'excel-table-2007 fixed-width-table table-hover' }, [
                is.make('thead', { 'class': 'thead-light-blue' }, [
                  is.make('tr', {}, [
                    is.make('th', {}, [is.text('Selección')]),
                    is.make('th', {}, [is.text('Archivo')]),
                  ]),
                ]),
                is.make('tbody', {}, [
                  is.make('tr', {}, [
                    is.make('td', {}, [
                      is.make('div', { 'class': 'form-group' }, [
                        is.make('input', { 'type': 'radio', 'class': 'form-control', 'name': 'numero_plantilla_feria_convivienda', 'value': '1' }),
                      ]),
                    ]),
                    is.make('td', {}, [
                      is.make('img', { 'class': 'rounded mx-auto d-block', 'width': '100px', 'src': 'https://completo365.com/storage/medios/Pl0Z5wnW6jNErhib427of1f8A+M.jpg' }),
                    ]),
                  ]),
                  is.make('tr', {}, [
                    is.make('td', {}, [
                      is.make('div', { 'class': 'form-group' }, [
                        is.make('input', { 'type': 'radio', 'class': 'form-control', 'name': 'numero_plantilla_feria_convivienda', 'value': '2' }),
                      ]),
                    ]),
                    is.make('td', {}, [
                      is.make('img', { 'class': 'rounded mx-auto d-block', 'width': '100px', 'src': 'https://completo365.com/storage/medios/OKRAjt5m6kTtrBQ4+rjwfjJBX6g.jpg' }),
                    ]),
                  ]),
                  is.make('tr', {}, [
                    is.make('td', {}, [
                      is.make('div', { 'class': 'form-group' }, [
                        is.make('input', { 'type': 'radio', 'class': 'form-control', 'name': 'numero_plantilla_feria_convivienda', 'value': '3' }),
                      ]),
                    ]),
                    is.make('td', {}, [
                      is.make('img', { 'class': 'rounded mx-auto d-block', 'width': '100px', 'src': 'https://completo365.com/storage/medios/Iaynj6tNkY46ik62mhaklOcMTuo.jpg' }),
                    ]),
                  ]),
                  is.make('tr', {}, [
                    is.make('td', {}, [
                      is.make('div', { 'class': 'form-group' }, [
                        is.make('input', { 'type': 'radio', 'class': 'form-control', 'name': 'numero_plantilla_feria_convivienda', 'value': '4' }),
                      ]),
                    ]),
                    is.make('td', {}, [
                      is.make('img', { 'class': 'rounded mx-auto d-block', 'width': '100px', 'src': 'https://completo365.com/storage/medios/c5BEMY7gfTfCVslphytWkstn3qM.jpg' }),
                    ]),
                  ]),
                ]),
                is.make('tfoot', {}, [
                  is.make('tr', {}, [
                    is.make('td'),
                    is.make('td'),
                  ]),
                ]),
              ]),
            ]),
          ]),
        }
      } else if (this.regExpTest('enviar_whatsapp_masivo_saber_si_cliente_esta_interesado\\b', trigger.value) === true) {
        title = {
          title: 'Masivo para notificación para ver si cliente continua interesado o no.',
          html: formMasivoSimilares,
        }
      }

      return this.massSaleConfirmationMessage(
        {
          trigger,
          ...title,
          confirmButtonText: 'Enviar',
        },
        idMarked,
      )
    },
    independentSelectionWhatsAppSaleEvent(event) {
      const trigger = event.target
      if (!this.checkVariable(trigger.value)) {
        return false
      }
      if (this.precontract && !this.checkVariable(this.precontract.imagen_firma_cedula_uri)) {
        this.defaultSettingsSwal()
        this.swalTitle = undefined
        this.swalText = `Antes de enviar la adenda al cliente, asegúrate de que haya creado su firma digital, ya que la adenda solo puede ser refrendada de forma digital.

        Si el cliente no desea firmar digitalmente o no puede hacerlo, deberás exportar la adenda y enviársela por este chat en PDF para que él la descargue, la firme manualmente y te la reenvíe firmada por este mismo medio.`
        this.positionedDialogToast()
        this.$store.dispatch('setUpdateStatus', this.generateRandomNumber(10))

        return false
      }

      let title = {}
      const defaultInput = {
        input: 'textarea',
        inputPlaceholder: 'Agrega un comentario',
        inputAttributes: {
          'aria-label': 'Escribe tu mensaje aquí',
        },
        column: 'message',
      }
      if (this.regExpTest('enviar_para_firma_contrato_whatsapp\\b', trigger.value) === true) {
        title = { title: 'Mensaje para Firma Contrato', text: '', ...defaultInput }
      } else if (this.regExpTest('enviar_para_completar_datos_whatsapp\\b', trigger.value) === true) {
        title = { title: 'Mensaje para Completar Datos/Requisitos', text: '', ...defaultInput }
      } else if (this.regExpTest('enviar_formulario_bancario_whatsapp\\b', trigger.value) === true) {
        title = { title: 'Mensaje para Completar Formulario Bancario', text: '', ...defaultInput }
      } else if (this.regExpTest('enviar_para_completar_estatus_laboral\\b', trigger.value) === true) {
        title = { title: 'Mensaje para Completar Estatus Labora', text: '', ...defaultInput }
      } else if (this.regExpTest('enviar_para_firmar_adenda_whatsapp\\b', trigger.value) === true) {
        if (this.determinesInspectionAction(['changeFinalPriceAddendum']) === true) {
          let finalPrice = 0
          if (!this.checkVariable(this.precontract.precio_final_adenda) && this.precontract.precio_final > 0) {
            finalPrice = this.precontract.precio_final
          } else if (this.checkVariable(this.precontract.precio_final_adenda) && this.precontract.precio_final_adenda > 0) {
            finalPrice = this.precontract.precio_final_adenda
          }
          const form = is.make('form', {}, [
            is.make('div', { 'class': 'form-group' }, [is.make('textarea', { 'rows': 10, 'cols': 50, 'class': 'form-control', 'name': 'message', 'id': 'swal2-whats-app-message', placeholder: 'Agrega un comentario' })]),
            is.make('div', { 'class': 'form-group' }, [is.make('input', { 'type': 'number', value: finalPrice, 'class': 'form-control', 'name': 'precio_final_adenda', 'id': 'swal2--whats-app-precio_final_adenda', placeholder: 'Precio venta' })]),
          ])
          title = {
            title: 'Mensaje para Firma de Adenda',
            text: '',
            html: form,
          }
        } else {
          title = { title: 'Mensaje para Firma de Adenda', text: '', ...defaultInput }
        }
      } else if (this.regExpTest('enviar_para_firmar_declaracion_jurada_mivi_whatsapp\\b', trigger.value) === true) {
        title = { title: 'Enviar a este cliente Whatsapp para firma Declaración Jurada MIVI', text: '', ...defaultInput }

        return this.checkAndSendForSignMIVISwornDeclaration('whatsapp', trigger, title)
      } else if (this.regExpTest('enviar_para_completar_grupo_familiar_whatsapp\\b', trigger.value) === true) {
        title = { title: 'Enviar mensaje de Whatsapp para completar información de Grupo Familiar e Ingresos Familiares', text: '', ...defaultInput }
      } else if (this.regExpTest('enviar_para_firmar_autorizacion_apc_banco_nacional_whatsapp\\b', trigger.value) === true) {
        title = { title: 'Enviar mensaje de Whatsapp para firma Autorización APC del Banco Nacional', text: '', ...defaultInput }
      } else if (this.regExpTest('enviar_para_firmar_autorizacion_apc_la_hipotecaria_whatsapp\\b', trigger.value) === true) {
        title = { title: 'Enviar mensaje de Whatsapp para firma Autorización APC del Banco La Hipotecaria', text: '', ...defaultInput }
      } else if (this.regExpTest('enviar_para_firmar_autorizacion_apc_la_caja_de_ahorro_whatsapp\\b', trigger.value) === true) {
        title = { title: 'Enviar mensaje de Whatsapp para firma Autorización APC del Banco La Caja de ahorro', text: '', ...defaultInput }
      } else if (this.regExpTest('enviar_para_aceptar_utilizacion_firmar_autorizacion_verificacion_apc\\b', trigger.value) === true) {
        title = { title: 'Enviar mensaje de Whatsapp para aceptar la utilización de la firma y certificar la autorización de Verificación de APC', text: '' }
      } else if (this.regExpTest('enviar_para_aceptar_utilizacion_firmar_contrato_promesa_compra_venta\\b', trigger.value) === true) {
        title = { title: 'Enviar mensaje de Whatsapp para aceptar la utilización de la firma y certificar el Contrato de Promesa de Compra - Venta', text: '' }
      }

      return this.confirmationMessageWhatsappSale({
        trigger,
        ...title,
        confirmButtonText: 'Enviar',
      })
    },
    selectionSMSSaleEvent(event, idMarked) {
      const trigger = event.target
      if (this.checkVariable(trigger.value)) {
        let title = {}
        if (this.regExpTest('enviar_sms_masivo_suscribirse_notificaciones_navegador\\b', trigger.value) === true) {
          title = { title: 'SMS para Suscribir a notificaciones del navegador', text: '' }
        }

        return this.massiveSharesSales(
          {
            trigger,
            ...title,
            confirmButtonText: 'Enviar',
          },
          idMarked,
        )
      }
    },
    independentSelectionSMSSaleEvent(event) {
      const trigger = event.target
      if (this.checkVariable(trigger.value)) {
        let title = {}
        if (this.regExpTest('enviar_sms_suscribirse_notificaciones_navegador\\b', trigger.value) === true) {
          title = { title: 'SMS para Suscribirse a notificaciones del navegador', text: '' }
        }

        return this.performVariousSalesAction({
          url: trigger.value,
          ...title,
          confirmButtonText: 'Enviar',
        })
      }
    },
    async _getEventFile(target) {
      const data = {}
      const name = is.getUniqueAttribute(target, 'name')
      if (target.files) {
        /** @var Array datos */
        const emptyDatos = await this.asyncGetNaturalSizeImage(target.files)
        let countInter = 0
        const datos = await new Promise((resolve) => {
          timeEsperarTamanioArchivos = setInterval(() => {
            if (emptyDatos && emptyDatos.length > 0) {
              resolve(emptyDatos)
            }
            if (countInter >= 100) {
              resolve([])
            }
            countInter = countInter + 1
          }, 100)
        })
        clearInterval(timeEsperarTamanioArchivos)
        /** @var Promise NaturalData */
        const NaturalData = this.getTheFirstWithout(datos)
        const { width, height } = NaturalData
        const file = await this.asyncTakeCareOfCompressingOnly(target, width, height)
        data[name] = file
      } else {
        data[name] = target.value
      }

      return data
    },
    _disableOrEnableTarget(event, desOrHabi) {
      if (this.isArray(event)) {
        event.forEach(async e => {
          const target = e.target
          target.disabled = desOrHabi
        })
      } else {
        event.target.disabled = desOrHabi
      }
    },
    async handleSalesFileUpload(event, url, dataToRevert = null, messageToRevert = null, alternativeUrlToRevert = null) {
      this._disableOrEnableTarget(event, true)
      const data = {}
      if (this.isArray(event)) {
        event.forEach(async e => {
          const target = e.target
          const promise = this._getEventFile(target)
          promise.then(res => {
            Object.assign(data, res)
          })
        })
      } else {
        const promise = this._getEventFile(event.target)
        promise.then(res => {
          Object.assign(data, res)
        })
      }

      // Script para retrasar hasta que el objeto contenga valores
      const finished = await new Promise((resolve) => {
        let count = 0
        timeEndsEventFiles = setInterval(() => {
          const test = Object.entries(data).filter(([key, value]) => (value instanceof File && key))
          if (test && test.length > 0) {
            resolve(data)
          }
          if (count >= 100) {
            resolve({})
          }
          count++
        }, 100)
      })

      this.captureDataToRevert('asign_sales', dataToRevert, messageToRevert, alternativeUrlToRevert)

      clearInterval(timeEndsEventFiles)

      const promise = axios.post(url, this.objectToFormData(finished))
        .then(response => {
          this._disableOrEnableTarget(event, false)
          this.defaultSettingsToastSwal()
          this.swalTitle = this.$t('update_response')
          this.swalText = undefined
          this.positionedDialogToast()
          this.$root.$emit('triggerSwitchRevertDataToast', true)
          this.$store.dispatch('setUpdateStatus', this.generateRandomNumber(10))

          return response
        }).catch(error => {
          this._disableOrEnableTarget(event, false)

          return error
        })

      if (this.$refs.loadingComponent && this.$refs.loadingComponent.load instanceof Function) {
        this.$refs.loadingComponent.load(promise)
      }

      return promise
    },
    storeSelectionSaleEvent(url, revertActionUrl) {
      if (!this.checkVariable(this.imagen_verificada)) {
        return null
      }

      this.captureDataForVerifyImages(revertActionUrl)
      const promise = axios.post(url, this.objectToFormData({ ...this.imagen_verificada }))
        .then(response => {
          this.defaultSettingsToastSwal()
          this.swalTitle = this.$t('update_response')
          this.swalText = undefined
          this.positionedDialogToast()
          this.$root.$emit('triggerSwitchRevertDataToast', true)
          this.$store.dispatch('setUpdateStatus', this.generateRandomNumber(10))

          return response
        }).catch(error => {
          return error
        })

      this.$refs.loadingComponent.load(promise)

      return promise
    },
    archiveSaleImage(e, url, urlToRevert) {
      this.defaultSettingsSwal()
      const swal = this.setupSwal()
      const path = is.getAttributeValue(e.currentTarget, 'uri')

      return swal.fire({
        title: this.$t('store'),
        text: this.$t('remove_text'),
        showCancelButton: true,
        preConfirm: () => {
          const data = {}
          data[`archivar_${path}`] = true

          const form = this.objectToFormData({ ...data })
          this.captureDataForArchiveImageFile(path, urlToRevert)

          return axios.post(url, form)
        },
      }).then(response => {
        if (this.checkVariable(response) && this.checkVariable(response.isConfirmed) && response.isConfirmed) {
          this.defaultSettingsToastSwal()
          this.swalTitle = this.$t('update_response')
          this.swalText = undefined
          this.positionedDialogToast()
          this.$root.$emit('triggerSwitchRevertDataToast', true)
          this.$store.dispatch('setUpdateStatus', this.generateRandomNumber(10))
        }

        return response
      })
    },
    async updateInfoTabSale(url, revertActionUrl) {
      if (!this.checkVariable(this.fichaInfoForm)) {
        return null
      }

      this.captureDataForUpdateFichaInfo(revertActionUrl)

      await this.fichaInfoForm.post(url)
      this.defaultSettingsToastSwal()
      this.swalTitle = this.$t('update_response')
      this.swalText = undefined
      this.positionedDialogToast()
      this.$root.$emit('triggerSwitchRevertDataToast', true)
      this.$store.dispatch('setUpdateStatus', this.generateRandomNumber(10))
    },
    updateLotSale(idLot, url) {
      this.defaultSettingsSwal()
      const swal = this.setupSwal()

      return swal.fire({
        title: 'Actualización de lote',
        showCancelButton: true,
        showConfirmButton: true,
        preConfirm: () => {
          this.captureDataForUpdateLote()

          return axios.post(url, this.objectToFormData({ lote_id: idLot }))
        },
      }).then(response => {
        this.lotAllocation.lote_id = null
        if (this.checkVariable(response) && this.checkVariable(response.isConfirmed) && response.isConfirmed) {
          this.defaultSettingsToastSwal()
          this.swalTitle = this.$t('update_response')
          this.swalText = undefined
          this.positionedDialogToast()
          this.$root.$emit('triggerSwitchRevertDataToast', true)
          this.$store.dispatch('setUpdateStatus', this.generateRandomNumber(10))
        }

        return response
      })
    },
    changeFinalPriceSale(id, finalPrice, url, urlToRevert) {
      this.defaultSettingsSwal()
      const swal = this.setupSwal()

      return swal.fire({
        title: 'Cambiar Precio Final',
        text: 'Ingresar precio final neto de la vivienda (sin bono solidario)',
        input: 'number',
        inputValue: finalPrice,
        validationMessage: 'Debe ingresar un número',
        showCancelButton: true,
        showConfirmButton: true,
        preConfirm: precio_final => {
          const form = is.objectToFormData({ precio_final })
          const message = 'Se actualizó el Precio Final del Cliente.'
          this.captureDataToRevert('asign_sales', [{ id, columns: [{ column: 'precio_final', value: finalPrice }] }], message, urlToRevert)

          return axios.post(url, form)
        },
      }).then(response => {
        if (this.checkVariable(response) && this.checkVariable(response.isConfirmed) && response.isConfirmed) {
          this.defaultSettingsToastSwal()
          this.swalTitle = this.$t('update_response')
          this.swalText = undefined
          this.positionedDialogToast()
          this.$root.$emit('triggerSwitchRevertDataToast', true)
          this.$store.dispatch('setUpdateStatus', this.generateRandomNumber(10))
        }

        return response
      })
    },
    changeProcedureDocumentsStatusSale(document_column, document_url, url) {
      const promise = axios.get(document_url)
      this.defaultSettingsSwal()
      const swal = this.setupSwal()

      return promise.then(response => {
        return swal.fire({
          title: 'Cambiar Estado',
          input: 'select',
          inputPlaceholder: 'Seleccione un estado',
          inputOptions: response.data,
          showCancelButton: true,
          preConfirm: value => {
            const form = this.objectToFormData({ estado_id: value, document_column })
            this.captureDataForChangeProcedureDocumentStatus(document_column)

            return axios.post(url, form)
          },
        }).then(response => {
          if (this.checkVariable(response) && this.checkVariable(response.isConfirmed) && response.isConfirmed) {
            this.defaultSettingsToastSwal()
            this.swalTitle = this.$t('answering_change_procedure_document_status')
            this.swalText = undefined
            this.positionedDialogToast()
            this.$root.$emit('triggerSwitchRevertDataToast', true)
            this.$store.dispatch('setUpdateStatus', this.generateRandomNumber(10))
          }

          return response
        })
      })
    },
    resetProcedureDocumentStatusSale(document, url) {
      this.defaultSettingsSwal()
      const swal = this.setupSwal()

      return swal.fire({
        title: '¿Restablecer Estado?',
        confirmButtonText: 'Aceptar',
        showCancelButton: true,
        showConfirmButton: true,
        preConfirm: () => {
          const form = this.objectToFormData({ document })
          this.captureDataForResetProcedureDocumentStatus(document)

          return axios.post(url, form)
        },
      }).then(response => {
        if (this.checkVariable(response) && this.checkVariable(response.isConfirmed) && response.isConfirmed) {
          this.defaultSettingsToastSwal()
          this.swalTitle = this.$t('answering_change_procedure_document_status')
          this.swalText = undefined
          this.positionedDialogToast()
          this.$root.$emit('triggerSwitchRevertDataToast', true)
          this.$store.dispatch('setUpdateStatus', this.generateRandomNumber(10))
        }

        return response
      })
    },
    changeProcedureDocumentDateSale(document_column, url) {
      this.defaultSettingsSwal()
      const swal = this.setupSwal()

      swal.fire({
        title: 'Seleccione una Fecha',
        html: '<input id="fecha" type="text" placeholder="Escoga una fecha"><br>',
        showCancelButton: true,
        onOpen: function () {
          $('#fecha').datepicker()
        },
        preConfirm: () => {
          const fecha = is.getNode('#fecha').value
          if (is.checkVariable(fecha)) {
            const form = this.objectToFormData({ document_column, fecha })
            this.captureDataForChangeProcedureDocumentDate(document_column)

            return axios.post(url, form)
          }

          swal.showValidationMessage('Debe suministrar una fecha.')
        },
      }).then(response => {
        if (this.checkVariable(response) && this.checkVariable(response.isConfirmed) && response.isConfirmed) {
          this.defaultSettingsToastSwal()
          this.swalTitle = this.$t('answering_change_procedure_document_status')
          this.swalText = undefined
          this.positionedDialogToast()
          this.$root.$emit('triggerSwitchRevertDataToast', true)
          this.$store.dispatch('setUpdateStatus', this.generateRandomNumber(10))
        }

        return response
      })
    },
    changeSatusDeedPublicRegistrationSale(trigger, url) {
      const escriturasCerradas = is.getAttributeValue(trigger, 'escriturasCerradas')
      this.defaultSettingsSwal()
      const swal = this.setupSwal()

      if (is.checkVariable(escriturasCerradas)) {
        swal.fire({
          title: '¿Marcar Escrituras como Ingresadas al Registro Público?',
          confirmButtonText: 'Aceptar',
          showCancelButton: true,
          showConfirmButton: true,
          preConfirm: () => {
            this.captureDataForChangeSatusDeedPublicRegistration()

            return axios.post(url, {})
          },
        }).then(response => {
          if (this.checkVariable(response) && this.checkVariable(response.isConfirmed) && response.isConfirmed) {
            this.defaultSettingsToastSwal()
            this.swalTitle = this.$t('update_response')
            this.swalText = undefined
            this.positionedDialogToast()
            this.$root.$emit('triggerSwitchRevertDataToast', true)
            this.$store.dispatch('setUpdateStatus', this.generateRandomNumber(10))
          }
        })
      }
      else {
        swal.fire({
          icon: 'error',
          title: 'Las Escrituras deben estar Recibidas/Cerradas primero',
          showCancelButton: false,
          showLoaderOnConfirm: false,
        })
      }
    },
    changeStatusDeedOutlaySale(trigger, url) {
      const escriturasCerradas = is.getAttributeValue(trigger, 'escriturasCerradas')
      this.defaultSettingsSwal()
      const swal = this.setupSwal()

      if (is.checkVariable(escriturasCerradas)) {
        swal.fire({
          title: '¿Marcar como Desembolsada?',
          confirmButtonText: 'Aceptar',
          showCancelButton: true,
          showConfirmButton: true,
          preConfirm: () => {
            this.captureDataForChangeStatusDeedOutlay()

            return axios.post(url, {})
          },
        }).then(response => {
          if (this.checkVariable(response) && this.checkVariable(response.isConfirmed) && response.isConfirmed) {
            this.defaultSettingsToastSwal()
            this.swalTitle = this.$t('update_response')
            this.swalText = undefined
            this.positionedDialogToast()
            this.$root.$emit('triggerSwitchRevertDataToast', true)
            this.$store.dispatch('setUpdateStatus', this.generateRandomNumber(10))
          }
        })
      }
      else {
        swal.fire({
          icon: 'error',
          title: 'Las Escrituras deben estar Recibidas/Cerradas primero',
          showCancelButton: false,
          showLoaderOnConfirm: false,
        })
      }
    },
    attachProcedureDocumentSale(column, url) {
      this.defaultSettingsSwal()
      const swal = this.setupSwal()

      return swal.fire({
        title: 'Adjuntar un Documento',
        input: 'file',
        confirmButtonText: 'Aceptar',
        showCancelButton: true,
        showConfirmButton: true,
        preConfirm: file => {
          const form = is.objectToFormData({ column, file })
          this.captureDataForAttachProcedureDocumentSale(column)

          return axios.post(url, form)
        },
      }).then(response => {
        if (this.checkVariable(response) && this.checkVariable(response.isConfirmed) && response.isConfirmed) {
          this.defaultSettingsToastSwal()
          this.swalTitle = this.$t('update_response')
          this.swalText = undefined
          this.positionedDialogToast()
          this.$root.$emit('triggerSwitchRevertDataToast', true)
          this.$store.dispatch('setUpdateStatus', this.generateRandomNumber(10))
        }

        return response
      })
    },
    sendNewCostumerFormEmailSale(event) {
      const promise = axios.get('/api/sale/project_models/list_available_project_models')
      this.defaultSettingsSwal()
      const swal = this.setupSwal()
      const url = event.target.value

      return promise.then(response => {
        event.target.value = ''
        return swal.fire({
          title: 'Enviar formulario a nuevo Cliente',
          text: 'Seleccione un modelo de casa',
          input: 'select',
          inputOptions: response.data,
          confirmButtonText: 'Siguiente',
          showCancelButton: true,
          showConfirmButton: true,
          preConfirm: (value) => {
            const modelo_proyecto_id = value
            swal.fire({
              title: 'Enviar formulario a nuevo Cliente',
              text: 'Ingrese el Correo Eletrónico del Cliente',
              input: 'text',
              showCancelButton: true,
              confirmButtonText: 'Aceptar',
              inputValidator: (value) => {
                if (!value) {
                  return 'Debe proporcionar un Email válido'
                }
              },
              preConfirm: (value) => {
                const form = this.objectToFormData({ email: value, modelo_proyecto_id })

                return axios.post(url, form)
              },
            }).then(response => {
              if (this.checkVariable(response) && this.checkVariable(response.isConfirmed) && this.checkVariable(response.value)) {
                this.defaultSettingsToastSwal()
                this.swalTitle = 'Correo enviado'
                this.swalText = undefined
                this.positionedDialogToast()
              }

              return response
            })
          },
        })
      })
    },
    sendNewCostumerFormWhatsappSale(event) {
      const promise = axios.get('/api/sale/project_models/list_available_project_models')
      this.defaultSettingsSwal()
      const swal = this.setupSwal()
      const processorId = is.getAttributeValue(event.currentTarget, 'processorId')
      const urlActionWhatsapp = event.target.value

      return promise.then(response => {
        event.target.value = ''
        swal.fire({
          title: 'Enviar formulario a nuevo Cliente',
          text: 'Seleccione un modelo de casa',
          input: 'select',
          inputOptions: response.data,
          confirmButtonText: 'Siguiente',
          showCancelButton: true,
          showConfirmButton: true,
          preConfirm: (value) => {
            const modeloProyectoId = value
            swal.fire({
              title: 'Enviar formulario a nuevo Cliente',
              text: 'Ingrese el número de celular del Cliente',
              input: 'text',
              showCancelButton: true,
              confirmButtonText: 'Siguiente',
              inputValidator: (value) => {
                if (!value) {
                  return 'Debe proporcionar un número válido'
                }
              },
              preConfirm: (value) => {
                const celular = value
                swal.fire({
                  title: 'Enviar formulario a nuevo Cliente',
                  text: 'Escriba un mensaje',
                  input: 'textarea',
                  showCancelButton: true,
                  confirmButtonText: 'Aceptar',
                  preConfirm: (value) => {
                    const mensaje = value
                    const url = `${is.getValueSetting('appUrl')}/compra/nuevo/${modeloProyectoId}/${processorId}`

                    const text = `${mensaje} ${url}`
                    const phone = /^(507)/.test(celular) ? celular : `507${celular}`

                    const form = this.objectToFormData({ celular, modelo_proyecto_id: modeloProyectoId })
                    const newPromise = axios.post(urlActionWhatsapp, form)

                    return newPromise.then(() => {
                      const newParams = this.createTheParametersOfTheUrl({ phone, text })

                      window.open(`https://api.whatsapp.com/send${newParams}`, '_blank')
                    })
                  },
                }).then(response => {
                  if (this.checkVariable(response) && this.checkVariable(response.isConfirmed) && this.checkVariable(response.value)) {
                    this.defaultSettingsToastSwal()
                    this.swalTitle = 'Mensaje enviado'
                  }

                  return response
                })
              },
            })
          },
        })
      })
    },
    selectBanktoSendEmail() {
      const promise = axios.get('/api/bank_type_contacts/list_names_with_bank')
      this.defaultSettingsSwal()
      const swal = this.setupSwal()

      return promise.then(response => {
        return swal.fire({
          title: 'Seleccionar Banco',
          text:
            'Seleccione el banco al cual se enviará la Solicitud de Hipoteca ' +
            'y los documento del Cliente',
          input: 'select',
          inputPlaceholder: 'Seleccione un banco',
          inputOptions: response.data,
          showCancelButton: true,
          preConfirm: () => {
            return null
          },
        }).then(response => {
          if (this.checkVariable(response) && this.checkVariable(response.isConfirmed) && response.isConfirmed) {
            this.defaultSettingsToastSwal()
            this.swalTitle = this.$t('answering_change_procedure_document_status')
            this.swalText = undefined
            this.positionedDialogToast()
            this.$store.dispatch('setUpdateStatus', this.generateRandomNumber(10))
          }

          return response
        })
      })
    },
    archiveClientSale(url, number, visibility, currentVisibility, urlToRevert) {
      this.defaultSettingsSwal()
      const swal = this.setupSwal()
      const confirmText = visibility === 1 ? this.$t('show_client') : this.$t('hide_client')
      const messageToRevert = visibility === 1 ? this.$t('hidden_costumer_changed_to_visible') : this.$t('costumer_hidden')

      return swal.fire({
        title: `${confirmText} #${number}`,
        input: 'textarea',
        inputPlaceholder: 'Agrega un comentario',
        inputAttributes: {
          'aria-label': 'Escribe tu mensaje aquí',
        },
        confirmButtonText: confirmText,
        inputValidator: (value) => {
          if (!this.checkVariable(value)) {
            return '¡Necesitas escribir algo!'
          }
        },
        showCancelButton: true,
        preConfirm: text => {
          const form = is.objectToFormData({ descripcion: text, visibilidad: visibility })
          this.captureDataToRevert('asign_sales', [{ id: number, columns: [{ column: 'visibilidad', value: currentVisibility }] }], messageToRevert, urlToRevert)

          return axios.post(url, form)
        },
      }).then(response => {
        if (this.checkVariable(response) && this.checkVariable(response.isConfirmed) && response.isConfirmed) {
          this.defaultSettingsToastSwal()
          this.swalTitle = this.$t('update_response')
          this.swalText = undefined
          this.positionedDialogToast()
          this.$root.$emit('triggerSwitchRevertDataToast', true)
          this.$store.dispatch('setUpdateStatus', this.generateRandomNumber(10))
        }

        return response
      })
    },
    reuseModelChangeSale(item, url) {
      this.defaultSettingsSwal()
      const swal = this.setupSwal()

      swal.fire({
        title: '¿Desea volver a utilizar esta información?',
        confirmButtonText: 'Reutilizar',
        showCancelButton: true,
        preConfirm: () => {
          const { precio, letra } = item
          const form = this.objectToFormData({ precio, letra })
          this.captureDataForReuseModelChangeSale()

          return axios.post(url, form)
        },
      }).then(response => {
        if (this.checkVariable(response) && this.checkVariable(response.isConfirmed) && response.isConfirmed) {
          this.defaultSettingsToastSwal()
          this.swalTitle = this.$t('update_response')
          this.swalText = undefined
          this.positionedDialogToast()
          this.$root.$emit('triggerSwitchRevertDataToast', true)
          this.$store.dispatch('setUpdateStatus', this.generateRandomNumber(10))
        }

        return response
      })
    },
    changeModelProjectAvailabilitySale(title, url, item) {
      this.defaultSettingsSwal()
      const swal = this.setupSwal()

      swal.fire({
        title,
        confirmButtonText: 'Aceptar',
        showCancelButton: true,
        preConfirm: () => {
          this.capturaDataForChangeModelProjectAvailabilitySale(item)

          return axios.get(url)
        },
      }).then(response => {
        if (this.checkVariable(response) && this.checkVariable(response.isConfirmed) && response.isConfirmed) {
          this.defaultSettingsToastSwal()
          this.swalTitle = this.$t('update_response')
          this.swalText = undefined
          this.positionedDialogToast()
          this.$root.$emit('triggerSwitchRevertDataToast', true)
          this.$store.dispatch('setUpdateStatus', this.generateRandomNumber(10))
        }

        return response
      })
    },
    sendMinuteMailProcedure(url) {
      this.defaultSettingsSwal()
      const swal = this.setupSwal()

      return swal.fire({
        title: 'Enviar minutas por Correo',
        text: 'Ingrese la dirección de correo electrónico o muchos separados por coma (,)',
        input: 'text',
        showCancelButton: true,
        showConfirmButton: true,
        preConfirm: email => {
          const form = is.objectToFormData({ email })

          return axios.post(url, form)
        },
      }).then(response => {
        if (this.checkVariable(response) && this.checkVariable(response.isConfirmed) && response.isConfirmed) {
          this.defaultSettingsToastSwal()
          this.swalTitle = this.$t('update_response')
          this.swalText = undefined
          this.positionedDialogToast()
          this.$store.dispatch('setUpdateStatus', this.generateRandomNumber(10))
        }

        return response
      })
    },
    sendPermitEmailProcedure(url) {
      this.defaultSettingsSwal()
      const swal = this.setupSwal()

      return swal.fire({
        title: 'Enviar Permisos Adjuntos por Correo',
        text: 'Ingrese la(s) dirección(es) de correo electrónico (si son varias, separadas por coma ",").',
        input: 'text',
        showCancelButton: true,
        showConfirmButton: true,
        preConfirm: email => {
          const form = is.objectToFormData({ email })

          return axios.post(url, form)
        },
      }).then(response => {
        if (this.checkVariable(response) && this.checkVariable(response.isConfirmed) && response.isConfirmed) {
          this.defaultSettingsToastSwal()
          this.swalTitle = this.$t('update_response')
          this.swalText = undefined
          this.positionedDialogToast()
          this.$store.dispatch('setUpdateStatus', this.generateRandomNumber(10))
        }

        return response
      })
    },
    registerClientAgentAction(url) {
      const promise = axios.post(url)
        .then(response => {
          this.defaultSettingsToastSwal()
          this.swalTitle = this.$t('update_response')
          this.swalText = undefined
          this.positionedDialogToast()
          this.$store.dispatch('setUpdateStatus', this.generateRandomNumber(10))

          return response
        }).catch(error => {
          return error
        })

      return promise
    },
    attachSalesRequest(url, bankId) {
      if (!this.determinesInspectionAction(['list'])) {
        return
      }

      const promise = axios.get('/api/bank_type/list')
      this.defaultSettingsSwal()
      const swal = this.setupSwal()

      return promise.then(response => {
        const { data } = response
        const banks = [{ '': '--SELECCIONAR--' }]
        const temBanks = this.getArrayValues(this.checkVariable(data) && this.isArray(data.data) ? data.data : [], 'id', 'nombre')
        const newBankId = this.checkVariable(bankId) ? bankId.toString() : ''
        const form = is.make('form', {}, [
          is.make('div', { 'class': 'form-group' }, [is.make('label', { 'for': 'banco_solicitud_bancaria_id' }, [is.text('Seleccione un banco')]), is.select(this.concat(banks, temBanks), { 'class': 'form-control', 'name': 'banco_solicitud_bancaria_id', 'id': 'banco_solicitud_bancaria_id' }, newBankId)]),
          is.make('div', { 'class': 'form-group' }, [is.make('label', { 'for': 'banco_solicitud_bancaria_uri' }, [is.text('Adjunte la Solicitud Hipotecaria')]), is.make('input', { 'type': 'file', 'multiple': false, 'class': 'form-control', 'name': 'banco_solicitud_bancaria_uri', 'id': 'banco_solicitud_bancaria_uri' })]),
          is.make('div', { 'class': 'form-group' }, [is.make('label', { 'for': 'autorizacion_apc_uri' }, [is.text('Adjunte Autorizacion APC')]), is.make('input', { 'type': 'file', 'multiple': false, 'class': 'form-control', 'name': 'autorizacion_apc_uri', 'id': 'autorizacion_apc_uri' })]),
          is.make('div', { 'class': 'form-group' }, [is.make('label', { 'for': 'banco_aseguradora_uri' }, [is.text('Adjunte Prueba de Aseguradora')]), is.make('input', { 'type': 'file', 'multiple': false, 'class': 'form-control', 'name': 'banco_aseguradora_uri', 'id': 'banco_aseguradora_uri' })]),
          is.make('div', { 'class': 'form-group' }, [is.make('label', { 'for': 'archivo_banco_otro_a_uri' }, [is.text('Adjunte otro archivo')]), is.make('input', { 'type': 'file', 'multiple': false, 'class': 'form-control', 'name': 'archivo_banco_otro_a_uri', 'id': 'archivo_banco_otro_a_uri' })]),
          is.make('div', { 'class': 'form-group' }, [is.make('label', { 'for': 'archivo_banco_otro_b_uri' }, [is.text('Adjunte otro archivo')]), is.make('input', { 'type': 'file', 'multiple': false, 'class': 'form-control', 'name': 'archivo_banco_otro_b_uri', 'id': 'archivo_banco_otro_b_uri' })]),
          is.make('div', { 'class': 'form-group' }, [is.make('label', { 'for': 'archivo_banco_otro_c_uri' }, [is.text('Adjunte otro archivo')]), is.make('input', { 'type': 'file', 'multiple': false, 'class': 'form-control', 'name': 'archivo_banco_otro_c_uri', 'id': 'archivo_banco_otro_c_uri' })]),
        ])

        return swal.fire({
          title: 'Adjuntar Solicitud',
          text: 'Seleccione el banco al cual se realizó el proceso. ',
          html: form,
          confirmButtonText: 'Adjuntar solicitud bancaria',
          showCancelButton: true,
          preConfirm: () => {
            const bankId = is.nodeWith(form, '#banco_solicitud_bancaria_id') ? is.getNodeWith(form, '#banco_solicitud_bancaria_id').value : null
            const bankRequestFile = is.nodeWith(form, '#banco_solicitud_bancaria_uri') ? is.getNodeWith(form, '#banco_solicitud_bancaria_uri').files[0] : null
            const APCAutorizationFile = is.nodeWith(form, '#autorizacion_apc_uri') ? is.getNodeWith(form, '#autorizacion_apc_uri').files[0] : null
            const insuranceBankFile = is.nodeWith(form, '#banco_aseguradora_uri') ? is.getNodeWith(form, '#banco_aseguradora_uri').files[0] : null
            const fileBankOtherA = is.nodeWith(form, '#archivo_banco_otro_a_uri') ? is.getNodeWith(form, '#archivo_banco_otro_a_uri').files[0] : null
            const fileBankOtherB = is.nodeWith(form, '#archivo_banco_otro_b_uri') ? is.getNodeWith(form, '#archivo_banco_otro_b_uri').files[0] : null
            const fileBankOtherC = is.nodeWith(form, '#archivo_banco_otro_c_uri') ? is.getNodeWith(form, '#archivo_banco_otro_c_uri').files[0] : null
            const newForm = this.objectToFormData({
              banco_solicitud_bancaria_id: bankId,
              archivo_solicitud_bancaria: bankRequestFile,
              archivo_autorizacion_apc: APCAutorizationFile,
              archivo_aseguradora: insuranceBankFile,
              archivo_banco_otro_a: fileBankOtherA,
              archivo_banco_otro_b: fileBankOtherB,
              archivo_banco_otro_c: fileBankOtherC,
            })

            return axios.post(url, newForm)
          },
        }).then(response => {
          if (this.checkVariable(response) && this.checkVariable(response.isConfirmed) && response.isConfirmed) {
            this.defaultSettingsToastSwal()
            this.swalTitle = this.$t('answering_change_procedure_document_status')
            this.swalText = undefined
            this.positionedDialogToast()
            this.$store.dispatch('setUpdateStatus', this.generateRandomNumber(10))
          }

          return response
        })
      })
    },
    cropChangeSale(e) {
      if (!this.isUndefined(this.positions)) {
        const { pos, el } = e
        const nw = is.getAttributeValue(el, 'nw')
        const nh = is.getAttributeValue(el, 'nh')
        const ow = is.getAttributeValue(el, 'ow')
        const oh = is.getAttributeValue(el, 'oh')
        const url = is.getBase64Image(el)
        const file = is.dataURLtoFile(url, 'firma')

        this.positions = { img: file, nw, nh, ow, oh, x: pos.x, y: pos.y, w: pos.w, h: pos.h }
      }

      return e
    },
    async createClientSignatureSale(url, createClientSignatureForm, positions) {
      if (!this.isObject(positions)) {
        return new Promise((resolve, reject) => {
          reject('Sin posiciones')
        })
      }
      if (!this.checkVariable(createClientSignatureForm.color_firma)) {
        return new Promise((resolve, reject) => {
          reject('Que color tiene la firma')
        })
      }

      const { img, nw, nh, ow, oh, x, y, w, h } = positions
      this.$set(createClientSignatureForm, 'posiciones', JSON.stringify({ nw, nh, ow, oh, x, y, w, h }))
      this.$set(createClientSignatureForm, 'firma', img)

      return createClientSignatureForm.post(url, this.transformRequest()).then(response => {
        this.defaultSettingsToastSwal()
        this.swalTitle = this.$t('update_response')
        this.swalText = undefined
        this.positionedDialogToast()
        this.$store.dispatch('setUpdateStatus', this.generateRandomNumber(10))

        return response
      })
    },
    /**
     * @param {String} path
     * @param {Array} idMarked
     * @return {Promise}
     */
    assignModelMassivelySales(path, idMarked, collection, indexColumn = 'id') {
      let form = this.createAdvancedFilter(path)
      if (this.isObject(form) && this.getAmountOfKeys(idMarked) > 0) {
        const arrVal = []
        Object.keys(idMarked).forEach(key => {
          if (this.checkVariable(idMarked[key])) {
            arrVal.push(idMarked[key])
          }
        })
        form['id_marked'] = arrVal
      }

      this.defaultSettingsSwal()
      const swal = this.setupSwal()
      const promise = axios.get('/api/sale/project_models/list')
      promise.then(response => {
        const tem = []
        response.data.forEach(dato => {
          const { id, name } = dato
          tem[id] = name
        })

        return swal.fire({
          title: 'Seleccione un Modelo',
          input: 'select',
          inputPlaceholder: 'Seleccione de la lista',
          inputOptions: tem,
          showCancelButton: true,
          preConfirm: value => {
            form = this.objectToFormData({ ...form, modelo_proyecto_id: value })
            this.captureDataForAssignModelMassivelySales(idMarked, collection, indexColumn, path)

            return axios.post(`${path}/asignar_masivamente_modelo_proyecto`, form)
          },
        }).then(response => {
          if (this.checkVariable(response) && this.checkVariable(response.isConfirmed) && response.isConfirmed) {
            this.defaultSettingsToastSwal()
            this.swalTitle = this.$t('project_model_assignment_response')
            this.swalText = undefined
            this.positionedDialogToast()
            this.$root.$emit('triggerSwitchRevertDataToast', true)
            this.$store.dispatch('setUpdateStatus', this.generateRandomNumber(10))
          }

          return response
        })
      })

      return promise
    },
    massivelyHideClientSalesAction({
      title,
      confirmButtonText,
      path,
      action,
      idMarked,
      collection,
      indexColumn = 'id',
      visibilidad,
    }) {
      let form = this.createAdvancedFilter(path)
      if (this.isObject(form) && this.getAmountOfKeys(idMarked) > 0) {
        const arrVal = []
        Object.keys(idMarked).forEach(key => {
          if (this.checkVariable(idMarked[key])) {
            arrVal.push(idMarked[key])
          }
        })
        form['id_marked'] = arrVal
      }

      this.defaultSettingsSwal()
      const swal = this.setupSwal()
      swal.fire({
        title,
        input: 'textarea',
        inputPlaceholder: 'Agrega un comentario',
        inputAttributes: {
          'aria-label': 'Escribe tu mensaje aquí',
        },
        inputValidator: (value) => {
          if (!this.checkVariable(value)) {
            return '¡Necesitas escribir algo!'
          }
        },
        confirmButtonText,
        showCancelButton: true,
        preConfirm: descripcion => {
          form = this.objectToFormData({ ...form, descripcion, visibilidad })
          this.captureDataForMassivelyHideClientSales(idMarked, collection, indexColumn, path)

          return axios.post(`${path}/${action}`, form)
        },
      }).then(response => {
        if (this.checkVariable(response) && this.checkVariable(response.isConfirmed) && response.isConfirmed) {
          this.defaultSettingsToastSwal()
          this.swalTitle = this.$t('update_response')
          this.swalText = undefined
          this.positionedDialogToast()
          this.$root.$emit('triggerSwitchRevertDataToast', true)
          this.$store.dispatch('setUpdateStatus', this.generateRandomNumber(10))
        }

        return response
      })
    },
    /**
     * @param {String} path
     * @param {Array} idMarked
     * @return {Promise}
     */
    massivelyHideClientSales(path, idMarked, collection, indexColumn = 'id') {
      return this.massivelyHideClientSalesAction({
        path,
        idMarked,
        collection,
        indexColumn,
        title: '¿Desea ocultar los clientes filtrados?',
        confirmButtonText: 'Ocultar',
        action: 'ocultar_masivamente_clientes',
        visibilidad: false,
      })
    },
    /**
     * @param {String} path
     * @param {Array} idMarked
     * @return {Promise}
     */
    massivelyUnhideClientSales(path, idMarked, collection, indexColumn = 'id') {
      return this.massivelyHideClientSalesAction({
        path,
        idMarked,
        collection,
        indexColumn,
        title: '¿Desea desocultar los clientes filtrados?',
        confirmButtonText: 'Desocultar',
        action: 'desocultar_masivamente_clientes',
        visibilidad: true,
      })
    },
    masivoExportarContratosPromesaSegunFiltro(path, idMarked) {
      let form = this.createAdvancedFilter(path)
      if (this.isObject(form) && this.getAmountOfKeys(idMarked) > 0) {
        const arrVal = []
        Object.keys(idMarked).forEach(key => {
          if (this.checkVariable(idMarked[key])) {
            arrVal.push(idMarked[key])
          }
        })
        form['id_marked'] = arrVal
      }

      form = this.objectToFormData({ ...form })

      axios.post(`${path}/exportar_contrato_clientes_segun_filtro`, form)
        .then(() => {
          this.defaultSettingsToastSwal()
          this.swalTitle = this.$t('notification_completion_contract_creation')
          this.swalText = undefined
          this.positionedDialogToast()
          this.$store.dispatch('setUpdateStatus', this.generateRandomNumber(10))
        })
    },
    masivoExportarFiltro(path, idMarked, queryPath='/filtro_excel') {
      let form = this.createAdvancedFilter(path)
      if (this.isObject(form) && this.getAmountOfKeys(idMarked) > 0) {
        const arrVal = []
        Object.keys(idMarked).forEach(key => {
          if (this.checkVariable(idMarked[key])) {
            arrVal.push(idMarked[key])
          }
        })
        form['id_marked'] = arrVal
      }

      form = this.objectToFormData({ ...form })

      axios.post(`${path}${queryPath}`, form)
        .then(() => {
          this.defaultSettingsToastSwal()
          this.swalTitle = this.$t('notification_completion_filter_precontrato')
          this.swalText = undefined
          this.positionedDialogToast()
          this.$store.dispatch('setUpdateStatus', this.generateRandomNumber(10))
        })
    },
    masivoExportarFiltroConTabla(path, others, idMarked, queryPath='/filtro_excel') {
      let form = this.createAdvancedFilter(path)
      if (this.isObject(form) && this.getAmountOfKeys(idMarked) > 0) {
        const arrVal = []
        Object.keys(idMarked).forEach(key => {
          if (this.checkVariable(idMarked[key])) {
            arrVal.push(idMarked[key])
          }
        })
        form['id_marked'] = arrVal
      }

      form = this.objectToFormData({ ...form, ...others })

      axios.post(`${path}${queryPath}`, form)
        .then(() => {
          this.defaultSettingsToastSwal()
          this.swalTitle = this.$t('notification_completion_filter_precontrato')
          this.swalText = undefined
          this.positionedDialogToast()
          this.$store.dispatch('setUpdateStatus', this.generateRandomNumber(10))
        })
    },
    markAppointmentAsAssisted() {
      const appointment = this.precontract.cita
      this.defaultSettingsSwal()
      const swal = this.setupSwal()

      swal.fire({
        title: '¿Marcar que el Cliente asistió a la Cita?',
        showCancelButton: true,
        preConfirm: () => {
          this.captureDataForMarkAppointmentAsAssisted(appointment)

          axios.get(`/api/sale/appointments/mark_as_assisted/${appointment.id}`)
            .then((response) => {
              if (this.checkVariable(response) && this.checkVariable(response.data) && response.data === 'ok') {
                this.defaultSettingsToastSwal()
                this.swalTitle = this.$t('update_response')
                this.swalText = undefined
                this.positionedDialogToast()
                this.$root.$emit('triggerSwitchRevertDataToast', true)
                this.$store.dispatch('setUpdateStatus', this.generateRandomNumber(10))
              }
            })
        },
      })
    },

    /**
     * @param {String} url
     * @param {Object} createClientSignatureForm
     * @param {String} selectedSignature
     * @return {Promise}
     */
    async createSignatureWithSelectionSale(url, createClientSignatureForm, selectedSignature) {
      if (!this.checkVariable(url)) {
        return false
      }
      if (!this.checkVariable(selectedSignature)) {
        return false
      }
      if (!this.checkVariable(createClientSignatureForm)) {
        return false
      }

      const domImg = is.make('img', { 'src': this.renderUrl(selectedSignature) })
      const dataUrl = is.getBase64Image(domImg)
      const file = is.dataURLtoFile(dataUrl, this.randomString(20))
      this.$set(createClientSignatureForm, 'firma', file)

      return createClientSignatureForm.post(url, this.transformRequest()).then(response => {
        this.defaultSettingsToastSwal()
        this.swalTitle = this.$t('update_response')
        this.swalText = undefined
        this.positionedDialogToast()
        this.$store.dispatch('setUpdateStatus', this.generateRandomNumber(10))

        return response
      })
    },
    storeSelection(event) {
      const { selected, route_server } = event
      const promise = this.createSignatureWithSelectionSale(route_server, this.createSignatureWithSelectionForm, selected)
      if (promise === false) {
        return false
      }
      promise.then(response => {
        // Message
        this.defaultSettingsToastSwal()
        this.swalTitle = 'Se ha aplicado correctamente. '
        this.swalText = undefined
        this.positionedDialogToast()

        return response
      }).catch(error => {
        return error
      })

      return promise
    },
    sendProformaDownloadSale(url) {
      this.defaultSettingsSwal()
      const swal = this.setupSwal()

      return swal.fire({
        title: 'Envío de la Proforma',
        text: '',
        input: 'textarea',
        inputPlaceholder: 'Agregar un comentario',
        inputAttributes: {
          step: 'any',
          autocapitalize: 'off',
        },
        showCancelButton: true,
        preConfirm: value => {
          const form = is.objectToFormData({ message: value })

          return axios.post(url, form)
        },
      }).then(response => {
        if (this.checkVariable(response) && this.checkVariable(response.isConfirmed) && response.isConfirmed) {
          this.defaultSettingsToastSwal()
          this.swalTitle = this.$t('proforma_sent')
          this.swalText = undefined
          this.positionedDialogToast()
          this.$store.dispatch('setUpdateStatus', this.generateRandomNumber(10))
        }

        return response
      })
    },
    prepareChangeStatusBankRequest(url, model, indexColumn = 'id', path) {
      if (!this.determinesInspectionAction(['list'])) {
        return
      }

      const columns = this.getColumnsAndValuesArrayToRevert(model, ['estado_solicitud_bancaria_id', 'fecha_estado_solicitud_bancaria', 'banco_solicitud_bancaria_id', 'tipo_banco_contacto_id'])
      const message = 'se actualizó estado de la solicitud bancaria.'
      const urlToRevert = `${path}/revert_action`

      const promise = axios.get('/api/bank_type/list')
      this.defaultSettingsSwal()
      const swal = this.setupSwal()

      return promise.then(response => {
        const { data } = response
        const bankId = model.banco_solicitud_bancaria_id
        const banks = [{ '': '--SELECCIONAR--' }]
        const temBanks = this.getArrayValues(this.checkVariable(data) && this.isArray(data.data) ? data.data : [], 'id', 'nombre')
        const newBankId = this.checkVariable(bankId) ? bankId.toString() : ''
        const form = is.make('form', {}, [
          is.make('div', { 'class': 'form-group' }, [is.make('label', { 'for': 'banco_solicitud_bancaria_id' }, [is.text('Seleccione un banco')]), is.select(this.concat(banks, temBanks), { 'class': 'form-control', 'name': 'banco_solicitud_bancaria_id', 'id': 'banco_solicitud_bancaria_id' }, newBankId)]),
          is.make('div', { 'class': 'form-group' }, [is.make('label', { 'for': 'agente_nombre' }, [is.text('Nombre del Oficial Bancario')]), is.make('input', { 'type': 'text', 'class': 'form-control', 'name': 'agente_nombre', 'id': 'agente_nombre' })]),
          is.make('div', { 'class': 'form-group' }, [is.make('label', { 'for': 'agente_email' }, [is.text('Correo del Oficial Bancario')]), is.make('input', { 'type': 'text', 'class': 'form-control', 'name': 'agente_email', 'id': 'agente_email' })]),
        ])

        return swal.fire({
          title: this.$t('send_request_bank'),
          text: '',
          html: form,
          confirmButtonText: this.$t('send_request'),
          showCancelButton: true,
          preConfirm: () => {
            const bankId = is.nodeWith(form, '#banco_solicitud_bancaria_id') ? is.getNodeWith(form, '#banco_solicitud_bancaria_id').value : null
            const agentName = is.nodeWith(form, '#agente_nombre') ? is.getNodeWith(form, '#agente_nombre').value : null
            const agentEmail = is.nodeWith(form, '#agente_email') ? is.getNodeWith(form, '#agente_email').value : null
            const newForm = this.objectToFormData({
              banco_solicitud_bancaria_id: bankId,
              agente_nombre: agentName,
              agente_email: agentEmail,
            })

            return axios.post(url, newForm)
          },
        }).then(response => {
          const { isConfirmed, value: responseServer } = response
          const success = this.getObjectValue(responseServer, 'data.success')

          if (this.getBoolValue(isConfirmed) === true && this.getBoolValue(success) === true) {
            this.defaultSettingsToastSwal()
            this.swalTitle = this.$t('update_response')
            this.swalText = undefined
            this.positionedDialogToast()
            this.captureDataToRevert('update_sales', [{ id: model[indexColumn], columns }], message, urlToRevert)
            this.$root.$emit('triggerSwitchRevertDataToast', true)
            this.$store.dispatch('setUpdateStatus', this.generateRandomNumber(10))

            const agentEmail = is.nodeWith(form, '#agente_email') ? is.getNodeWith(form, '#agente_email').value : null
            if (this.checkVariable(agentEmail) && this.determinesInspectionAction(['openMailClient'])) {
              window.open(`mailto:${agentEmail}?subject=Documentos%20para%20aplicar%20a%20Hipoteca&body=${this.detailTextDocumentsApplyMortgage()}`, '_blank')
            }
          } else if (this.getBoolValue(isConfirmed) === true && this.getBoolValue(success) === false) {
            this.defaultSettingsToastSwal()
            this.swalTitle = this.$t('no_update_response')
            this.swalText = undefined
            this.positionedDialogToast()
            this.$store.dispatch('setUpdateStatus', this.generateRandomNumber(10))
          }

          return response
        })
      })
    },
    prepareChangeStateDoesNotApply(url, model, indexColumn = 'id', path) {
      const columns = this.getColumnsAndValuesArrayToRevert(model, ['estado_solicitud_bancaria_id', 'fecha_estado_solicitud_bancaria', 'archivo_carta_aprobacion_uri', 'archivo_carta_promesa_uri', 'archivo_cesion_bancaria_uri', 'financiamiento_monto'])
      const message = 'Se actualizó Estado a No Aplica del Cliente.'
      const urlToRevert = `${path}/revert_action`

      this.changeOfSaleStatus(url, model[indexColumn], columns, message, urlToRevert)
    },
    prepareChangeStatusIsNotInterested(url, model, indexColumn = 'id', path) {
      const columns = this.getColumnsAndValuesArrayToRevert(model, ['estado_precontrato_id', 'fecha_estado_precontrato'])
      const message = 'Se actualizó Estado a No le Interesa del Cliente.'
      const urlToRevert = `${path}/revert_action`

      this.changeOfSaleStatus(url, model[indexColumn], columns, message, urlToRevert)
    },
    prepareChangeCreatedState(url, model, indexColumn = 'id', path, modifiedColumns) {
      const columns = this.getColumnsAndValuesArrayToRevert(model, modifiedColumns)
      const message = 'Se actualizó Estado a En Blanco del Cliente.'
      const urlToRevert = `${path}/revert_action`

      this.changeOfSaleStatus(url, model[indexColumn], columns, message, urlToRevert)
    },
    captureDataForMassivelyAssignSalesAgent(idsMarked, collection, indexColumn = 'id', path, columnToRevertProcessorAssignment) {
      const columnsToAsign = [columnToRevertProcessorAssignment]
      const recordsToRevert = this.createRecordsArrayToRevertFromFilterableCollection(idsMarked, collection, columnsToAsign, indexColumn)
      const url = `${path}/revert_action`

      this.captureDataToRevert('asign_sales', recordsToRevert, 'Se actualizó el Tramitador de los registros seleccionados.', url)
    },
    captureDataForAssignModelMassivelySales(idsMarked, collection, indexColumn = 'id', path) {
      const columnsToAsign = ['modelo_proyecto_id', 'precio_final', 'promocion_tramites_final', 'lote_id', 'estado_precontrato_id', 'fecha_estado_precontrato', 'estado_adenda_cliente_id', 'fecha_estado_adenda_cliente', 'precio_final_adenda']
      const recordsToRevert = this.createRecordsArrayToRevertFromFilterableCollection(idsMarked, collection, columnsToAsign, indexColumn)
      const url = `${path}/revert_action`

      this.captureDataToRevert('asign_sales', recordsToRevert, 'Se actualizó el modelo de casa de los clientes seleccionados.', url)
    },
    captureDataForMassivelyHideClientSales(idsMarked, collection, indexColumn = 'id', path) {
      const columnsToAsign = ['visibilidad']
      const recordsToRevert = this.createRecordsArrayToRevertFromFilterableCollection(idsMarked, collection, columnsToAsign, indexColumn)
      const url = `${path}/revert_action`

      this.captureDataToRevert('asign_sales', recordsToRevert, 'Se ocultaron los clientes seleccionados.', url)
    },
    prepareForChangeAttachLetterPromise(dataObject, path) {
      const { id } = this.precontract
      const columns = this.getColumnsAndValuesArrayToRevert(this.precontract, ['estado_solicitud_bancaria_id', 'fecha_estado_solicitud_bancaria', 'archivo_carta_promesa_uri'])
      const message = 'Se actualizó Estado a Carta Promesa del Cliente.'
      const dataToRevert = [{ id, columns }]
      const url = `${path}/revert_action`

      this.attachSalesDocumentsAction(dataObject, dataToRevert, message, url)
    },
    prepareForChangeAddBankTransfer(dataObject, path) {
      const { id } = this.precontract
      const columns = this.getColumnsAndValuesArrayToRevert(this.precontract, ['estado_solicitud_bancaria_id', 'fecha_estado_solicitud_bancaria', 'archivo_cesion_bancaria_uri'])
      const message = 'Se actualizó Estado a Cesión Bancaria del Cliente.'
      const dataToRevert = [{ id, columns }]
      const url = `${path}/revert_action`

      this.attachSalesDocumentsAction(dataObject, dataToRevert, message, url)
    },
    prepareForDissociatePrecontrato(dataObject, model, indexColumn = 'id', path) {
      const id = model[indexColumn]
      const columns = this.getColumnsAndValuesArrayToRevert(model, ['lote_id', 'precio_final', 'promocion_tramites_final', 'estado_precontrato_id', 'fecha_estado_precontrato', 'estado_adenda_cliente_id', 'fecha_estado_adenda_cliente'])
      const message = 'Se Eliminó el lote asociado al Cliente.'
      const dataToRevert = [{ id, columns }]
      const url = `${path}/revert_action`

      this.performVariousSalesAction(dataObject, dataToRevert, message, url)
    },
    captureDataForVerifyImages(url) {
      const { id } = this.precontract
      const currentVerifiedImages = {}
      Object.keys(this.imagen_verificada).forEach(key => {
        currentVerifiedImages[key] = this.precontract[key]
      })

      this.captureDataToRevert('update_sales', [{ id, information: currentVerifiedImages }], 'Se actualizó información del Documento.', url)
    },
    captureDataForArchiveImageFile(path, url) {
      const { id } = this.precontract
      const message = 'Se archivó el Documento.'
      const uriBase = path.replace('_uri', '')
      const uriVerified = uriBase + '_verificada'
      const columnsToRevert = [path, uriVerified]

      if (uriBase === 'imagen_cedula' || uriBase === 'imagen_cedula_reverso') {
        columnsToRevert.push('estado_identificacion_id')
      } else if (uriBase === 'imagen_ficha' || uriBase === 'imagen_talonario' || uriBase === 'imagen_carta_trabajo') {
        columnsToRevert.push('estado_documento_id')
      } else if (uriBase === 'imagen_firma_cliente') {
        columnsToRevert.push('imagen_firma_cedula_uri')
      }

      const columns = this.getColumnsAndValuesArrayToRevert(this.precontract, columnsToRevert)

      this.captureDataToRevert('asign_sales', [{ id, columns }], message, url)
    },
    captureDataForUpdateFichaInfo(url) {
      const { id, ficha_meses, ficha_ultimo_mes } = this.precontract
      const message = 'Se actualizó datos de la Ficha del Cliente.'

      this.captureDataToRevert('update_ficha_sales', [{ id, fichaInfo: { ficha_meses, ficha_ultimo_mes } }], message, url)
    },
    captureDataForUpdateLote() {
      const { id, lote_id } = this.precontract
      const message = 'Se actualizó el Lote del Cliente.'
      const url = '/api/sale/precontracts/revert_action'

      this.captureDataToRevert('asign_sales', [{ id, columns: [{ column: 'lote_id', value: lote_id }] }], message, url)
    },
    captureDataForChangeProcedureDocumentStatus(documentColumn) {
      const { id } = this.precontract
      const message = 'Se actualizó el estado de la Minuta/Escritura/Paz y Salvo.'
      const columnsToRevert = [`${documentColumn}_id`, `fecha_${documentColumn}`, 'estado_minuta_id', 'fecha_estado_minuta', 'estado_escritura_id', 'fecha_estado_escritura']
      const columns = this.getColumnsAndValuesArrayToRevert(this.precontract, columnsToRevert)
      const url = '/api/sale/formalities/revert_action'

      this.captureDataToRevert('asign_sales', [{ id, columns }], message, url)
    },
    captureDataForResetProcedureDocumentStatus(documentColumn) {
      const { id } = this.precontract
      const message = 'Se restableció el estado de la Minuta/Escritura/Paz y Salvo.'
      const columnsToRevert = [`estado_${documentColumn}_id`, `fecha_estado_${documentColumn}`, 'estado_minuta_id', 'fecha_estado_minuta', 'estado_escritura_id', 'fecha_estado_escritura']
      const url = '/api/sale/formalities/revert_action'

      if (documentColumn !== 'minuta_venta' && documentColumn !== 'escritura_confeccion') {
        columnsToRevert.push(`archivo_${documentColumn}_uri`)
      }

      const columns = this.getColumnsAndValuesArrayToRevert(this.precontract, columnsToRevert)

      this.captureDataToRevert('asign_sales', [{ id, columns }], message, url)
    },
    captureDataForChangeProcedureDocumentDate(documentColumn) {
      const { id } = this.precontract
      const message = 'Se actualizó el fecha del estado de la Minuta/Escritura/Paz y Salvo.'
      const columnsToRevert = [`fecha_${documentColumn}`]
      const columns = this.getColumnsAndValuesArrayToRevert(this.precontract, columnsToRevert)
      const url = '/api/sale/formalities/revert_action'

      this.captureDataToRevert('asign_sales', [{ id, columns }], message, url)
    },
    captureDataForAttachProcedureDocumentSale(documentColumn) {
      const { id } = this.precontract
      const message = 'Se adjuntó Documento de Minuta/Escritura del Cliente.'
      const columnsToRevert = [`archivo_${documentColumn}_uri`, `estado_${documentColumn}_id`, `fecha_estado_${documentColumn}`]
      const columns = this.getColumnsAndValuesArrayToRevert(this.precontract, columnsToRevert)
      const url = '/api/sale/formalities/revert_action'

      this.captureDataToRevert('asign_sales', [{ id, columns }], message, url)
    },
    captureDataForChangeSatusDeedPublicRegistration() {
      const { id } = this.precontract
      const message = 'Se actualizó Estado de Escrituras a Ingresadas al Registro Público del Cliente.'
      const columnsToRevert = ['estado_escritura_id', 'estado_escritura_confeccion_id', 'estado_paz_y_salvo_id', 'estado_escritura_cliente_id', 'estado_escritura_hipotecario_id', 'estado_escritura_interino_id']
      const columns = this.getColumnsAndValuesArrayToRevert(this.precontract, columnsToRevert)
      const url = '/api/sale/formalities/revert_action'

      this.captureDataToRevert('asign_sales', [{ id, columns }], message, url)
    },
    captureDataForChangeStatusDeedOutlay() {
      const { id } = this.precontract
      const message = 'Se actualizó Estado de Escrituras a Desembolsada del Cliente.'
      const columnsToRevert = ['estado_escritura_id', 'estado_escritura_confeccion_id', 'estado_paz_y_salvo_id', 'estado_escritura_cliente_id', 'estado_escritura_hipotecario_id', 'estado_escritura_interino_id']
      const columns = this.getColumnsAndValuesArrayToRevert(this.precontract, columnsToRevert)
      const url = '/api/sale/formalities/revert_action'

      this.captureDataToRevert('asign_sales', [{ id, columns }], message, url)
    },
    captureDataForStateChangeReadyToSend() {
      const { id } = this.precontract
      const message = 'Se actualizó el estado de la solicitud bancaria.'
      const url = '/api/sale/precontracts/revert_action'
      const columnsToRevert = ['estado_solicitud_bancaria_id']
      const columns = this.getColumnsAndValuesArrayToRevert(this.precontract, columnsToRevert)

      this.captureDataToRevert('asign_sales',  [{ id, columns }], message, url)
    },
    sleepingClientSale(url) {
      this.defaultSettingsSwal()
      const swal = this.setupSwal()
      const values = []
      this.sleepingOptionClient.map((option, value) => {
        values.push({value, text: option})
      })
      const defaultOption = [{ '': '--SELECCIONAR--' }]
      const temValues = this.getArrayValues(values, 'value', 'text')
      const currentDate = is.toYYYYMMDDString(new Date())
      const formHTML = is.make('form', {}, [
        is.make('ul', {'class': 'nav nav-tabs', 'role': 'tablist'},[
          is.make('li', {'class': 'nav-item'}, [
            is.make('a', {'class': 'nav-link active', 'id': 'specificmonth-tab', 'data-toggle': 'tab', 'href': '#specificmonth', 'role': 'tab', 'aria-controls': 'specificmonth', 'aria-selected': 'true'}, [
              is.text('Mes específico'),
            ]),
          ]),
          is.make('li', {'class': 'nav-item'}, [
            is.make('a', {'class': 'nav-link', 'id': 'specificdate-tab', 'data-toggle': 'tab', 'href': '#specificdate', 'role': 'tab', 'aria-controls': 'specificdate', 'aria-selected': 'true'}, [
              is.text('Fecha específico'),
            ]),
          ]),
        ]),
        is.make('div', {'class': 'tab-content', 'id': 'myTabContent'}, [
          is.make('div', {'class': 'tab-pane fade show active', 'id': 'specificmonth', 'role': 'tabpanel', 'aria-labelledby': 'specificmonth-tab'}, [
            is.make('div', { 'class': 'form-group' }, [
              is.make('label', { 'for': 'mes' }, [is.text('Seleccione de la lista')]),
              is.select(defaultOption.concat(temValues), { 'class': 'form-control', 'name': 'mes', 'id': 'mes' }, ''),
            ]),
          ]),
          is.make('div', {'class': 'tab-pane fade', 'id': 'specificdate', 'role': 'tabpanel', 'aria-labelledby': 'specificdate-tab'}, [
            is.make('label', { 'for': 'mes' }, [is.text('Seleccione la fecha')]),
            is.make('input', {'type': 'date', 'id': 'fecha', 'name': 'fecha', 'min': currentDate}),
          ]),
        ]),
      ])

      listen(is.getNodeWithAll(formHTML, 'ul > li > a'), 'click', event => {
        const trigger = event.delegateTarget || event.currentTarget
        const id = is.getUniqueAttribute(trigger, 'id')

        switch (id) {
          case 'specificdate-tab':
            const mouth = is.getNodeWith(formHTML, 'select#mes')
            if (is.node(mouth)) {
              mouth.value = ''
            }
            break
          case 'specificmonth-tab':
            const date = is.getNodeWith(formHTML, 'input#fecha')
            if (is.node(date)) {
              date.value = null
            }

            break
        }
      })

      return swal.fire({
        title: `${this.$t('sleeping_client')}`,
        html: formHTML,
        confirmButtonText: 'Dormir cliente',
        showCancelButton: true,
        preConfirm: () => {
          const mes = (is.nodeWith(formHTML, '#mes')) ? is.getNodeWith(formHTML, 'select#mes').value : null
          const fecha = (is.nodeWith(formHTML, '#fecha')) ? is.getNodeWith(formHTML, 'input#fecha').value : null
          let form = null
          if (!mes && fecha) {
            form = is.objectToFormData({ fecha })
          } else if (mes && !fecha) {
            form = is.objectToFormData({ mes })
          }

          return form ? axios.post(url, form) : false
        },
      }).then(response => {
        if (this.checkVariable(response) && this.checkVariable(response.isConfirmed) && response.isConfirmed) {
          this.defaultSettingsToastSwal()
          this.swalTitle = this.$t('update_response')
          this.swalText = undefined
          this.positionedDialogToast()
          this.$store.dispatch('setUpdateStatus', this.generateRandomNumber(10))
        }

        return response
      })
    },
    markAsPrimarySale(url) {
      this.defaultSettingsSwal()
      const swal = this.setupSwal()

      return swal.fire({
        title: `${this.$t('change_state_primary_model')}`,
        confirmButtonText: this.$t('mark'),
        showCancelButton: true,
        preConfirm: () => {
          const form = is.objectToFormData()

          return axios.post(url, form)
        },
      }).then(response => {
        if (this.checkVariable(response) && this.checkVariable(response.isConfirmed) && response.isConfirmed) {
          this.defaultSettingsToastSwal()
          this.swalTitle = this.$t('update_response')
          this.swalText = undefined
          this.positionedDialogToast()
          this.$store.dispatch('setUpdateStatus', this.generateRandomNumber(10))
        }

        return response
      })
    },
    markAsSecondarySale(url) {
      this.defaultSettingsSwal()
      const swal = this.setupSwal()

      return swal.fire({
        title: `${this.$t('change_state_secondary_model')}`,
        confirmButtonText: this.$t('mark'),
        showCancelButton: true,
        preConfirm: () => {
          const form = is.objectToFormData()

          return axios.post(url, form)
        },
      }).then(response => {
        if (this.checkVariable(response) && this.checkVariable(response.isConfirmed) && response.isConfirmed) {
          this.defaultSettingsToastSwal()
          this.swalTitle = this.$t('update_response')
          this.swalText = undefined
          this.positionedDialogToast()
          this.$store.dispatch('setUpdateStatus', this.generateRandomNumber(10))
        }

        return response
      })
    },
    markAsNullSale(url) {
      this.defaultSettingsSwal()
      const swal = this.setupSwal()

      return swal.fire({
        title: `${this.$t('change_state_null_model')}`,
        confirmButtonText: this.$t('mark'),
        showCancelButton: true,
        preConfirm: () => {
          const form = is.objectToFormData()

          return axios.post(url, form)
        },
      }).then(response => {
        if (this.checkVariable(response) && this.checkVariable(response.isConfirmed) && response.isConfirmed) {
          this.defaultSettingsToastSwal()
          this.swalTitle = this.$t('update_response')
          this.swalText = undefined
          this.positionedDialogToast()
          this.$store.dispatch('setUpdateStatus', this.generateRandomNumber(10))
        }

        return response
      })
    },
    /**
     * @param {String} path
     */
    notifyImportedCustomerSale(path) {
      this.defaultSettingsSwal()
      const swal = this.setupSwal()

      const formHtml = is.make('form', {}, [
        is.make('div', { 'class': 'form-group' }, [is.make('label', { 'for': 'file' }, [is.text('Clientes')]), is.make('input', { 'type': 'file', 'class': 'form-control', 'name': 'file', 'id': 'file', 'accept': '.csv' })]),
        is.make('div', { 'class': 'form-group' }, [is.make('label', { 'for': 'numero_camp' }, [is.text('Campaña')]), is.make('input', { 'type': 'text', 'class': 'form-control', 'name': 'numero_camp', 'id': 'numero_camp' })]),
        is.make('fieldset', {}, [
          is.make('legend', {}, [is.text('Redirigir a')]),
          is.make('label', { 'class': 'form-check' }, [
            is.make('input', { 'type': 'radio', 'class': 'form-control', 'name': 'redirigir_a', 'value': 'web' }),
            is.text('Página Web'),
          ]),
          is.make('label', { 'class': 'form-check' }, [
            is.make('input', { 'type': 'radio', 'class': 'form-control', 'name': 'redirigir_a', 'value': 'whatsapp' }),
            is.text('Central'),
          ]),
          is.make('label', { 'class': 'form-check' }, [
            is.make('input', { 'type': 'radio', 'class': 'form-control', 'name': 'redirigir_a', 'value': 'agente' }),
            is.text('Agente'),
          ]),
        ]),
        is.make('div', { 'class': 'form-group' }, [is.make('label', { 'for': 'mensaje' }, [is.text('Personaliza el mensaje')]), is.make('textarea', { 'class': 'form-control', 'name': 'mensaje', 'id': 'mensaje' })]),
        is.make('div', { 'class': 'form-group d-none' }, [is.make('label', { 'for': 'mensaje_parte' }, [is.text('Auto respuesta')]), is.make('input', { 'type': 'text', 'class': 'form-control', 'name': 'mensaje_parte', 'id': 'mensaje_parte' })]),
      ])

      listen(is.getNodeWithAll(formHtml, 'input[name=redirigir_a]'), 'click', event => {
        const trigger = event.delegateTarget || event.currentTarget
        const value = trigger.value
        let autoRespuestaDefault = ''
        if (value === 'agente') {
          autoRespuestaDefault = 'Me interesa aplicar a un proyecto con la promoción de $1000.0 dólares contra entrega de la casa'
        } else if (value === 'whatsapp') {
          autoRespuestaDefault = 'Cliente Nuevo'
        }

        const parentNode = is.getNodeWith(formHtml, '#mensaje_parte').parentNode
        is.getNodeWith(formHtml, '#mensaje_parte').value = autoRespuestaDefault
        if (['agente', 'whatsapp'].indexOf(value) !== -1) {
          is.removeClass(parentNode, 'd-none')
        } else {
          is.addClass(parentNode, 'd-none')
        }
      })

      return swal.fire({
        title: this.$t('import_customer'),
        html: formHtml,
        showCancelButton: true,
        preConfirm: () => {
          const files = is.nodeWith(formHtml, '#file') ? is.getNodeWith(formHtml, '#file').files : null
          const numeroCamp = is.nodeWith(formHtml, '#numero_camp') ? is.getNodeWith(formHtml, '#numero_camp').value : null
          const redirigir = is.getNodeWith(formHtml, 'input[name="redirigir_a"]:checked')
          const redirigirA = is.node(redirigir) ? redirigir.value : null
          const mensaje = is.nodeWith(formHtml, '#mensaje') ? is.getNodeWith(formHtml, '#mensaje').value : null
          const mensajeParte = is.nodeWith(formHtml, '#mensaje_parte') ? this.replaceAll(is.getNodeWith(formHtml, '#mensaje_parte').value, ' ', '%20') : null

          const newForm = this.objectToFormData({
            numero_camp: numeroCamp,
            redirigir_a: redirigirA,
            mensaje,
            mensaje_parte: mensajeParte,
          })

          Object.keys(files).forEach(index => {
            const file = files[index]
            newForm.append(file.name, file)
          })

          return axios.post(`${path}/notify_imported_customer`, newForm)
        },
      }).then(response => {
        if (this.checkVariable(response) && this.checkVariable(response.isConfirmed) && response.isConfirmed) {
          this.defaultSettingsToastSwal()
          this.swalTitle = this.$t('answer_import_customer')
          this.swalText = undefined
          this.positionedDialogToast()
          // this.$store.dispatch('setUpdateStatus', this.generateRandomNumber(10))
        }

        return response
      })
    },
    captureDataForMarkAppointmentAsAssisted(appointment) {
      const { id } = appointment
      const columns = this.getColumnsAndValuesArrayToRevert(appointment, ['estado_cita_id'])
      const precontractColumns = this.getColumnsAndValuesArrayToRevert(this.precontract, ['cita_codigo'])
      const message = 'Se marcó la cita a estado "Asistió".'
      const url = '/api/sale/appointments/revert_action'

      this.captureDataToRevert('asign_sales', [{ id, columns, relatedTables: [{ relation: 'preContratoCliente', action: 'update', columns: precontractColumns }] }], message, url)
    },
    prepareForChangeModelArchitecturalPlantImage(objectData) {
      const { id, uri_planta_arquitectonica } = this.model
      const message = 'Se cambio la imagen de la planta arquitectónica.'
      const dataToRevert = [{ id, columns: [{ column: 'uri_planta_arquitectonica', value: uri_planta_arquitectonica }] }]
      const urlToRevert = '/api/sale/get_precontract_models/revert_action'

      this.attachSalesDocumentsAction(objectData, dataToRevert, message, urlToRevert)
    },
    prepareForHandleModelFileUploadPrecontract(event, url, urlToRevert) {
      const { id } = this.precontract
      const message = 'Se actualizó el archivo.'
      const columns = this.getColumnsAndValuesArrayToRevert(this.precontract, ['imagen_firma_cedula_uri', 'imagen_firma_cliente_uri', 'imagen_cedula_uri', 'imagen_cedula_reverso_uri', 'imagen_ficha_uri', 'imagen_talonario_uri', 'imagen_carta_trabajo_uri', 'imagen_recibo_uri'])
      const response = this.handleSalesFileUpload(event, url, [{ id, columns }], message, urlToRevert)

      return response
    },
    captureDataForReuseModelChangeSale() {
      const { id } = this.model
      const message = 'Se reutilizó el precio/letra seleccionado.'
      const columns = this.getColumnsAndValuesArrayToRevert(this.model, ['precio', 'letra'])
      const urlToRevert = '/api/sale/get_precontract_models/revert_action'

      this.captureDataToRevert('asign_sales', [{ id, columns, relatedTables: [{ relation: 'cambiosModelo', action: 'delete' }] }], message, urlToRevert)
    },
    capturaDataForChangeModelProjectAvailabilitySale(item) {
      const { id } = item
      const message = 'Se actualizó la disponibilidad del modelo en el proyecto seleccionado.'
      const urlToRevert = '/api/sale/project_models/revert_action'

      this.captureDataToRevert('asign_sales', [{ id, columns: [{ column: 'mostrar', value: item.disponible }] }], message, urlToRevert)
    },
    captureDataToMarkAsAssignedToClient(events, file, url, urlToRevert) {
      const {id} = this.precontract
      const message = 'Se marco el archivo como asignado.'

      this.captureDataToRevert(
        'asign_sales', [
          {
            id,
            relatedTables: [
              {
                relation: 'archivos_precontratocliente',
                action: 'update',
                pivots: [
                  {
                    id: file.id,
                    columns: { 'assigned': file.assigned },
                  },
                ],
              },
            ],
          },
        ],
        message,
        urlToRevert,
      )

      return this.makeAssignedFileMark(events, url, file)
    },
    applySolidarityBondSale(url, path, message) {
      this.defaultSettingsSwal()
      const swal = this.setupSwal()

      return swal.fire({
        title: `¿${message} al cliente?`,
        showConfirmButton: true,
        preConfirm: () => {
          this.captureDataForApplySolidarityBondSale(path)

          return axios.get(url)
        },
      }).then(response => {
        if (this.checkVariable(response) && this.checkVariable(response.isConfirmed) && response.isConfirmed) {
          this.defaultSettingsToastSwal()
          this.swalTitle = this.$t('update_response')
          this.swalText = undefined
          this.positionedDialogToast()
          this.$root.$emit('triggerSwitchRevertDataToast', true)
          this.$store.dispatch('setUpdateStatus', this.generateRandomNumber(10))
        }

        return response
      })
    },
    captureDataForApplySolidarityBondSale(path) {
      const { id } = this.precontract

      const attributesToRevert = [
        'aplica_bono_solidario',
        'gastos_legales_final',
        'gastos_tramites_final',
        'promocion_tramites_final',
        'promocion_precio_final',
        'letra_final',
        'total_a_pagar',
        'saldo',
      ]
      const columns = this.getColumnsAndValuesArrayToRevert(this.precontract, attributesToRevert)
      const message = 'Se actualizó aplicación del bono solidario del cliente.'
      const urlToRevert = `${path}/revert_action`

      this.captureDataToRevert('asign_sales', [{ id, columns }], message, urlToRevert)
    },
    changeStatusApprovedSale(url, path) {
      this.defaultSettingsSwal()
      const swal = this.setupSwal()

      const form = is.make('form', {}, [
        is.make('div', { 'class': 'form-group' }, [is.make('label', { 'for': 'file' }, [is.text('Adjuntar Carta de Aprobación')]), is.make('input', { 'type': 'file', 'class': 'form-control', 'name': 'file', 'id': 'file' })]),
        is.make('div', { 'class': 'form-group' }, [is.make('label', { 'for': 'financiamiento_monto' }, [is.text('Monto financiado por el Banco')]), is.make('input', { 'type': 'number', 'class': 'form-control', 'name': 'financiamiento_monto', 'id': 'financiamiento_monto' })]),
      ])

      return swal.fire({
        title: 'Aprobar solicitud bancaria',
        html: form,
        confirmButtonText: 'Aprobar',
        showCancelButton: true,
        preConfirm: () => {
          const files = is.nodeWith(form, '#file') ? is.getNodeWith(form, '#file').files : null
          const financiamientoMonto = is.nodeWith(form, '#financiamiento_monto') ? is.getNodeWith(form, '#financiamiento_monto').value : null
          const newForm = this.objectToFormData({ financiamiento_monto: financiamientoMonto, file: files[0] })

          this.captureDataForChangeStatusApproved(path)

          return axios.post(url, newForm)
        },
      }).then(response => {
        if (this.checkVariable(response) && this.checkVariable(response.isConfirmed) && response.isConfirmed) {
          this.defaultSettingsToastSwal()
          this.swalTitle = this.$t('update_response')
          this.swalText = undefined
          this.positionedDialogToast()
          this.$root.$emit('triggerSwitchRevertDataToast', true)
          this.$store.dispatch('setUpdateStatus', this.generateRandomNumber(10))
        }

        return response
      })
    },
    captureDataForChangeStatusApproved(path) {
      const { id } = this.precontract
      const attributesToRevert = [
        'estado_solicitud_bancaria_id',
        'fecha_estado_solicitud_bancaria',
        'financiamiento_monto',
        'archivo_carta_aprobacion_uri',
        'abono_inicial',
        'gastos_legales_final',
        'gastos_tramites_final',
        'promocion_tramites_final',
        'promocion_precio_final',
        'letra_final',
        'total_a_pagar',
        'saldo',
      ]
      const columns = this.getColumnsAndValuesArrayToRevert(this.precontract, attributesToRevert)
      const message = 'Se actualizó Estado a Aprobado del Cliente.'
      const dataToRevert = [{ id, columns }]
      const url = `${path}/revert_action`

      this.captureDataToRevert('asign_sales', dataToRevert, message, url)
    },
    requestLoanMemorandum() {
      const { uri_permiso_construccion_municipio, uri_permiso_ocupacion_municipio, estado_precontrato_firmado, estado_adenda_cliente_firmado, archivo_minuta_uri } = this.precontract
      this.documentsToSend = [
        {
          name: 'Minuta de Venta en formato WORD',
          url: this.renderUrlWeb(`/sale/formalities/${this.precontract.id}/generar_minuta_venta_work?token=${this.authToken}`),
          validated: this.checkIfDocumentExists(archivo_minuta_uri),
        },
        {
          name: 'Minuta de Venta en formato PDF',
          url: this.renderUrlWeb(`/sale/formalities/${this.precontract.id}/generar_minuta_venta?token=${this.authToken}`),
          validated: this.checkIfDocumentExists(archivo_minuta_uri),
        },
        {
          name: 'Permiso de Construcción Municipal',
          url: this.renderUrl(uri_permiso_construccion_municipio),
          validated: this.checkIfDocumentExists(uri_permiso_construccion_municipio),
        },
        {
          name: 'Permiso de Ocupación Municipal',
          url: this.renderUrl(uri_permiso_ocupacion_municipio),
          validated: this.checkIfDocumentExists(uri_permiso_ocupacion_municipio),
        },
        {
          name: 'Contrato de CompraVenta',
          url: this.renderUrlWeb(`/sale/formalities/${this.precontract.id}/generar?token=${this.authToken}`),
          validated: this.checkIfDocumentExists(estado_precontrato_firmado),
        },
        {
          name: 'Adenda',
          url: this.renderUrlWeb(`/sale/formalities/${this.precontract.id}/generar_adenda?token=${this.authToken}`),
          validated: this.checkIfDocumentExists(estado_adenda_cliente_firmado),
        },
      ]
      this.showMemorandumRequestModal('estado_minuta_hipotecario')
    },
    requestCancellationMemorandum() {
      this.documentsToSend = [
        {
          name: 'Carta de Cesión Bancaria',
          url: this.renderUrl(this.precontract.archivo_cesion_bancaria_uri),
          validated: this.checkIfDocumentExists(this.precontract.archivo_cesion_bancaria_uri),
        },
      ]
      this.showMemorandumRequestModal('estado_minuta_interino')
    },
    showMemorandumRequestModal(documentColumn) {
      if (!this.determinesInspectionAction(['list'])) {
        return
      }

      axios.get('/api/bank_type/list')
        .then(response => {
          const { data } = response
          this.bankList = this.checkVariable(data) && this.isArray(data.data) ? data.data : []
          this.requestMemorandumForm.banco_solicitud_bancaria_id = this.checkVariable(this.precontract.banco_solicitud_bancaria_id) ? this.precontract.banco_solicitud_bancaria_id.toString() : ''
          this.requestMemorandumForm.document_column = documentColumn
          this.requestMemorandumForm.estado_id = 1
          this.showModalRequestMemorandum()
        })
    },
    requestDeedConfection() {
      const { archivo_minuta_hipotecario_uri, archivo_minuta_interino_uri, archivo_minuta_uri, estado_precontrato_firmado, estado_adenda_cliente_firmado, imagen_cedula_uri, uri_plano_segregacion, uri_permiso_construccion_municipio, uri_permiso_ocupacion_municipio } = this.precontract
      this.documentsToSend = [
        {
          name: 'Minuta de Cancelación',
          url: this.renderUrl(archivo_minuta_interino_uri),
          validated: this.checkIfDocumentExists(archivo_minuta_interino_uri),
        },
        {
          name: 'Minuta de Préstamo',
          url: this.renderUrl(archivo_minuta_hipotecario_uri),
          validated: this.checkIfDocumentExists(archivo_minuta_hipotecario_uri),
        },
        {
          name: 'Minuta de Venta en formato WORD',
          url: this.renderUrlWeb(`/sale/formalities/${this.precontract.id}/generar_minuta_venta_work?token=${this.authToken}`),
          validated: this.checkIfDocumentExists(archivo_minuta_uri),
        },
        {
          name: 'Contrato de CompraVenta',
          url: this.renderUrlWeb(`/sale/formalities/${this.precontract.id}/generar?token=${this.authToken}`),
          validated: this.checkIfDocumentExists(estado_precontrato_firmado),
        },
        {
          name: 'Adenda',
          url: this.renderUrlWeb(`/sale/formalities/${this.precontract.id}/generar_adenda?token=${this.authToken}`),
          validated: this.checkIfDocumentExists(estado_adenda_cliente_firmado),
        },
        {
          name: 'Cédula',
          url: this.renderUrl(imagen_cedula_uri),
          validated: this.checkIfDocumentExists(imagen_cedula_uri),
        },
        {
          name: 'Copia del Plano de Segregación',
          url: this.renderUrl(uri_plano_segregacion),
          validated: this.checkIfDocumentExists(uri_plano_segregacion),
        },
        {
          name: 'Permiso de Construcción Municipal',
          url: this.renderUrl(uri_permiso_construccion_municipio),
          validated: this.checkIfDocumentExists(uri_permiso_construccion_municipio),
        },
        {
          name: 'Permiso de Ocupación Municipal',
          url: this.renderUrl(uri_permiso_ocupacion_municipio),
          validated: this.checkIfDocumentExists(uri_permiso_ocupacion_municipio),
        },
      ]
      this.sendPackageForm.document_column = 'estado_escritura_confeccion'
      this.sendPackageForm.estado_id = 1
      this.titleModalSendPackage = this.$t('request_deed_confection_by_email')
      this.urlSendPackage = `/api/sale/formalities/${this.precontract.id}/request_deed_confection`
      this.showModalSendPackage()
    },
    attachFinalDeed() {
      this.defaultSettingsSwal()
      const swal = this.setupSwal()

      return swal.fire({
        title: 'Adjuntar copia de las Escrituras',
        input: 'file',
        confirmButtonText: 'Aceptar',
        showCancelButton: true,
        showConfirmButton: true,
        preConfirm: file => {
          const form = is.objectToFormData({ file })
          this.captureDataForAttachFinalDeed()

          return axios.post(`/api/sale/formalities/${this.precontract.id}/attach_final_deed`, form)
        },
      }).then(response => {
        if (this.checkVariable(response) && this.checkVariable(response.isConfirmed) && response.isConfirmed) {
          this.defaultSettingsToastSwal()
          this.swalTitle = this.$t('answering_change_procedure_document_status')
          this.swalText = undefined
          this.positionedDialogToast()
          this.swalTitle = this.$t('update_response')
          this.swalText = undefined
          this.positionedDialogToast()
          this.$root.$emit('triggerSwitchRevertDataToast', true)
          this.$store.dispatch('setUpdateStatus', this.generateRandomNumber(10))
        }

        return response
      })
    },
    captureDataForAttachFinalDeed() {
      const { id, archivo_escritura_final_uri } = this.precontract
      const message = 'Se adjuntó copia de las Escrituras.'
      const url = '/api/sale/formalities/revert_action'

      this.captureDataToRevert('asign_sales', [{ id, columns: [{ column: 'archivo_escritura_final_uri', value: archivo_escritura_final_uri }] }], message, url)
    },
    sendEmailPackageMIVI(url) {
      const {
        archivo_carta_promesa_uri,
        estado_precontrato_firmado,
        estado_adenda_cliente_firmado,
        imagen_cedula_uri,
        imagen_carta_trabajo_uri,
        imagen_ficha_uri,
        tiene_cedulas_beneficiarios_mivi,
      } = this.precontract
      this.titleModalSendPackage = 'Enviar paquete con los datos del cliente al MIVI'
      this.documentsToSend = [
        {
          name: 'Declaración Jurada MIVI',
          url: this.renderUrlWeb(`/sale/formalities/${this.precontract.id}/generar_declaracion_jurada_mivi?token=${this.authToken}`),
          validated: true,
        },
        {
          name: 'Carta de Promesa',
          url: this.renderUrl(archivo_carta_promesa_uri),
          validated: this.checkIfDocumentExists(archivo_carta_promesa_uri),
        },
        {
          name: 'Contrato de CompraVenta',
          url: this.renderUrlWeb(`/sale/formalities/${this.precontract.id}/generar?token=${this.authToken}`),
          validated: this.checkIfDocumentExists(estado_precontrato_firmado),
        },
        {
          name: 'Adenda',
          url: this.renderUrlWeb(`/sale/formalities/${this.precontract.id}/generar_adenda?token=${this.authToken}`),
          validated: this.checkIfDocumentExists(estado_adenda_cliente_firmado),
        },
        {
          name: 'Cédula',
          url: this.renderUrl(imagen_cedula_uri),
          validated: this.checkIfDocumentExists(imagen_cedula_uri),
        },
        {
          name: 'Carta de Trabajo',
          url: this.renderUrl(imagen_carta_trabajo_uri),
          validated: this.checkIfDocumentExists(imagen_carta_trabajo_uri),
        },
        {
          name: 'Ficha de Seguro Social',
          url: this.renderUrl(imagen_ficha_uri),
          validated: this.checkIfDocumentExists(imagen_ficha_uri),
        },
        {
          name: 'Cédulas de los beneficiarios del Bono del MIVI',
          url: this.renderUrlWeb(`/sale/formalities/${this.precontract.id}/exportar_cedulas_beneficiarios_mivi?token=${this.authToken}`),
          validated: this.checkIfDocumentExists(tiene_cedulas_beneficiarios_mivi),
        },
      ]
      this.urlSendPackage = url
      this.showModalSendPackage()
    },
    sendTaxesRequest(url) {
      const { estado_precontrato_firmado, estado_adenda_cliente_firmado, uri_permiso_construccion_municipio, uri_permiso_ocupacion_municipio, imagen_cedula_uri } = this.precontract
      this.titleModalSendPackage = 'Enviar Solicitud para Impuestos'
      this.documentsToSend = [
        {
          name: 'Contrato de CompraVenta',
          url: this.renderUrlWeb(`/sale/formalities/${this.precontract.id}/generar?token=${this.authToken}`),
          validated: this.checkIfDocumentExists(estado_precontrato_firmado),
        },
        {
          name: 'Adenda',
          url: this.renderUrlWeb(`/sale/formalities/${this.precontract.id}/generar_adenda?token=${this.authToken}`),
          validated: this.checkIfDocumentExists(estado_adenda_cliente_firmado),
        },
        {
          name: 'Permiso de Construcción Municipal',
          url: this.renderUrl(uri_permiso_construccion_municipio),
          validated: this.checkIfDocumentExists(uri_permiso_construccion_municipio),
        },
        {
          name: 'Permiso de Ocupación Municipal',
          url: this.renderUrl(uri_permiso_ocupacion_municipio),
          validated: this.checkIfDocumentExists(uri_permiso_ocupacion_municipio),
        },
        {
          name: 'Cédula',
          url: this.renderUrl(imagen_cedula_uri),
          validated: this.checkIfDocumentExists(imagen_cedula_uri),
        },
      ]
      this.urlSendPackage = url
      this.showModalSendPackage()
    },
    checkForSendCostumerPackage() {
      const { uri_permiso_ocupacion_bomberos, uri_permiso_construccion_municipio, uri_permiso_ocupacion_municipio, archivo_escritura_final_uri } = this.precontract
      this.documentsToSend = [
        {
          name: 'Carta para instalación servicio de energía',
          url: this.renderUrlWeb(`/sale/formalities/${this.precontract.id}/generar_carta_instalacion_energia?token=${this.authToken}`),
          validated: true,
        },
        {
          name: 'Carta para instalación servicio de IDAAN',
          url: this.renderUrlWeb(`/sale/formalities/${this.precontract.id}/generar_carta_instalacion_idaan?token=${this.authToken}`),
          validated: true,
        },
        {
          name: 'Carta Autorización de Entrega',
          url: this.renderUrlWeb(`/sale/formalities/${this.precontract.id}/generar_carta_autorizacion_entrega?token=${this.authToken}`),
          validated: true,
        },
        {
          name: 'Permiso de Construcción Municipal',
          url: this.renderUrl(uri_permiso_construccion_municipio),
          validated: this.checkIfDocumentExists(uri_permiso_construccion_municipio),
        },
        {
          name: 'Permiso de Ocupación Municipal',
          url: this.renderUrl(uri_permiso_ocupacion_municipio),
          validated: this.checkIfDocumentExists(uri_permiso_ocupacion_municipio),
        },
        {
          name: 'Permiso de Ocupación Bomberos',
          url: this.renderUrl(uri_permiso_ocupacion_bomberos),
          validated: this.checkIfDocumentExists(uri_permiso_ocupacion_bomberos),
        },
        {
          name: 'Copia de las Escrituras',
          url: this.renderUrl(archivo_escritura_final_uri),
          validated: this.checkIfDocumentExists(archivo_escritura_final_uri),
        },
      ]
      this.showModalCostumerPackage()
    },
    sendCostumerPaymentRequest() {
      this.defaultSettingsSwal()
      const swal = this.setupSwal()

      return swal.fire({
        title: 'Enviar Solicitud de Pago al cliente por Correo y Whatsapp',
        input: 'textarea',
        inputPlaceholder: 'Agregar un comentario al mensaje de Whatsapp',
        inputAttributes: {
          'aria-label': 'Escribe tu mensaje aquí',
        },
        showCancelButton: true,
        preConfirm: (value) => {
          const newForm = this.objectToFormData({ message: value })

          return axios.post(`/api/sale/costumer_payments/${this.precontract.id}/enviar_solicitud_pago`, newForm)
        },
      }).then(response => {
        if (this.checkVariable(response) && this.checkVariable(response.isConfirmed) && response.isConfirmed) {
          const { value } = response

          if (this.checkVariable(value.config) && this.checkVariable(value.data)) {
            const formData = value.config.data
            const token = value.data.codigoPagoClienteNotificacion
            const celular = value.data.personas.celular
            const message = formData.get('message')
            const url = `${is.getValueSetting('appUrl')}/pagos_cliente/verificar_solicitud_pago/${token}`

            const text = `${message} ${url}`
            const phone = /^(507)/.test(celular) ? celular : `507${celular}`

            const newParams = this.createTheParametersOfTheUrl({ phone, text })
            window.open(`https://api.whatsapp.com/send${newParams}`, '_blank')
          }

          this.defaultSettingsToastSwal()
          this.swalTitle = this.$t('update_response')
          this.swalText = undefined
          this.positionedDialogToast()
          this.$store.dispatch('setUpdateStatus', this.generateRandomNumber(10))
        }

        return response
      })
    },
    forwardPaymentRequest(payment) {
      this.defaultSettingsSwal()
      const swal = this.setupSwal()

      return swal.fire({
        title: '¿Reenviar esta Solicitud de Pago por Email y Whatsapp?',
        input: 'textarea',
        inputPlaceholder: 'Agregar un comentario al mensaje de Whatsapp',
        inputAttributes: {
          'aria-label': 'Escribe tu mensaje aquí',
        },
        showCancelButton: true,
        preConfirm: (value) => {
          const form = this.objectToFormData({ message: value })

          return axios.post(`/api/sale/costumer_payments/${payment.id}/reenviar_solicitud_pago`, form)
        },
      }).then(response => {
        if (this.checkVariable(response) && this.checkVariable(response.isConfirmed) && response.isConfirmed) {
          const { value } = response

          if (this.checkVariable(value.config) && this.checkVariable(value.data)) {
            const formData = value.config.data
            const token = value.data.codigoPagoClienteNotificacion
            const celular = value.data.personas.celular
            const message = formData.get('message')
            const url = `${is.getValueSetting('appUrl')}/pagos_cliente/verificar_solicitud_pago/${token}`

            const text = `${message} ${url}`
            const phone = /^(507)/.test(celular) ? celular : `507${celular}`

            const newParams = this.createTheParametersOfTheUrl({ phone, text })
            window.open(`https://api.whatsapp.com/send${newParams}`, '_blank')
          }

          this.defaultSettingsToastSwal()
          this.swalTitle = this.$t('update_response')
          this.swalText = undefined
          this.positionedDialogToast()
          this.$store.dispatch('setUpdateStatus', this.generateRandomNumber(10))
        }

        return response
      })
    },
    approvePayment(payment) {
      const requestObject = {
        url: `/api/sale/costumer_payments/${payment.id}/approve_payment`,
        confirmationMessage: '¿Marcar pago como Aprobado?',
      }

      const revertObject = {
        id: payment.id,
        columns: this.getColumnsAndValuesArrayToRevert(payment, ['estado_id', 'fecha_estado']),
        relatedTables: [
          {
            relation: 'precontrato',
            action: 'update',
            columns: this.getColumnsAndValuesArrayToRevert(this.precontract, ['saldo', 'monto_ultimo_pago_aprobado', 'fecha_ultimo_pago_aprobado']),
          },
        ],
        message: 'Se actualizó Estado a Aprobado.',
        urlToRevert: '/api/sale/costumer_payments/revert_action',
      }

      this.changeStatusPayment(requestObject, revertObject)
    },
    rejectPayment(payment) {
      const requestObject = {
        url: `/api/sale/costumer_payments/${payment.id}/reject_payment`,
        confirmationMessage: '¿Marcar pago como Rechazado?',
      }

      const revertObject = {
        id: payment.id,
        columns: this.getColumnsAndValuesArrayToRevert(payment, ['estado_id', 'fecha_estado']),
        message: 'Se actualizó Estado a Rechazado.',
        urlToRevert: '/api/sale/costumer_payments/revert_action',
      }

      this.changeStatusPayment(requestObject, revertObject)
    },
    changeStatusPayment(requestObject, revertObject) {
      this.defaultSettingsSwal()
      const swal = this.setupSwal()

      return swal.fire({
        title: requestObject.confirmationMessage,
        showCancelButton: true,
        preConfirm: () => {
          this.captureDataToRevert('asign_sales', [{ id: revertObject.id, columns: revertObject.columns, relatedTables: revertObject.relatedTables }], revertObject.message, revertObject.urlToRevert)

          return axios.get(requestObject.url)
        },
      }).then(response => {
        if (this.checkVariable(response) && this.checkVariable(response.isConfirmed) && response.isConfirmed) {
          this.defaultSettingsToastSwal()
          this.swalTitle = this.$t('update_response')
          this.swalText = undefined
          this.positionedDialogToast()
          this.$root.$emit('triggerSwitchRevertDataToast', true)
          this.$store.dispatch('setUpdateStatus', this.generateRandomNumber(10))
        }

        return response
      })
    },
    changePurchaseURLSale(item, url) {
      this.defaultSettingsSwal()
      const swal = this.setupSwal()
      const urlCompra = this.checkVariable(item.url_compra) ? item.url_compra : ''

      return swal.fire({
        title: 'Cambiar URL de compra',
        input: 'url',
        inputPlaceholder: 'Escribir URL de compra',
        inputAttributes: {
          'aria-label': 'Escribir URL de compra',
        },
        validationMessage: 'Url Inválida',
        inputValue: urlCompra,
        showCancelButton: true,
        preConfirm: (value) => {
          const form = this.objectToFormData({ url_compra: value })
          this.captureDataForChangePurchaseURL(item)

          return axios.post(url, form)
        },
      }).then(response => {
        if (this.checkVariable(response) && this.checkVariable(response.isConfirmed) && response.isConfirmed) {
          this.defaultSettingsToastSwal()
          this.swalTitle = this.$t('update_response')
          this.swalText = undefined
          this.positionedDialogToast()
          this.$root.$emit('triggerSwitchRevertDataToast', true)
          this.$store.dispatch('setUpdateStatus', this.generateRandomNumber(10))
        }

        return response
      })
    },
    captureDataForChangePurchaseURL(item) {
      const { id, url_compra } = item
      const message = 'Se cambió la URL de compra.'
      const urlToRevert = '/api/sale/project_models/revert_action'

      this.captureDataToRevert('asign_sales', [{ id, columns: [{ column: 'url_compra', value: url_compra }] }], message, urlToRevert)
    },
    async sendPackageForRequestMemorandum(bvModalEvt) {
      bvModalEvt.preventDefault()

      await this.requestMemorandumForm.post(`/api/sale/formalities/${this.precontract.id}/request_memorandum`)
        .then(response => {
          this.hideModalRequestMemorandum()
          this.defaultSettingsToastSwal()
          this.swalTitle = this.$t('update_response')
          this.swalText = undefined
          this.positionedDialogToast()
          this.cleanRequestMemorandumForm()
          this.$store.dispatch('setUpdateStatus', this.generateRandomNumber(10))

          return response
        })
    },
    async sendPackage(bvModalEvt) {
      bvModalEvt.preventDefault()

      await this.sendPackageForm.post(this.urlSendPackage)
        .then(response => {
          this.hideModalSendPackage()
          this.defaultSettingsToastSwal()
          this.swalTitle = this.$t('update_response')
          this.swalText = undefined
          this.positionedDialogToast()
          this.cleanSendPackageForm()
          this.$store.dispatch('setUpdateStatus', this.generateRandomNumber(10))

          return response
        })
    },
    async sendPackageToCostumer(bvModalEvt) {
      bvModalEvt.preventDefault()

      await this.costumerPackageForm.post(`/api/sale/formalities/${this.precontract.id}/enviar_email_paquete_al_cliente`)
        .then(response => {
          this.hideModalCostumerPackage()
          this.defaultSettingsToastSwal()
          this.swalTitle = this.$t('update_response')
          this.swalText = undefined
          this.positionedDialogToast()
          this.cleanCostumerPackageForm()
          this.$store.dispatch('setUpdateStatus', this.generateRandomNumber(10))

          return response
        })
    },
    prepareForChangeModelVideo(objectData) {
      const { id, uri_video } = this.model
      const message = 'Se cambió el video promocional.'
      const dataToRevert = [{ id, columns: [{ column: 'uri_video', value: uri_video }] }]
      const urlToRevert = '/api/sale/get_precontract_models/revert_action'

      this.attachSalesDocumentsAction(objectData, dataToRevert, message, urlToRevert)
    },
    checkIfDocumentExists(attribute) {
      if (attribute) {
        return true
      }

      this.emailPackageCanBeSended = false

      return false
    },
    createListNumbersForSales() {
      const numbers = this.createListNumber(24, 'array')
      const temp = []
      numbers.forEach(number => {
        temp.push({ value: number, text: number })
      })

      return temp
    },
    checkAndSendForSignMIVISwornDeclaration(type, trigger, objectAlert) {
      const objectForm = {
        estado: 'estado_mivi',
        estadoModelo: 'App\\Models\\EstadoMIVIPrecontratoCliente',
        transicion: 'declaracion-jurada-enviada',
      }
      const form = this.objectToFormData(objectForm)

      return axios.post(`/api/sale/formalities/${this.precontract.id}/verificar_si_estado_puede_cambiar`, form)
        .then(response => {
          if (response && response.data) {
            const { permited, statusRequired } = response.data

            if (permited) {
              if (type === 'whatsapp') {
                return this.confirmationMessageWhatsappSale({
                  trigger,
                  ...objectAlert,
                  confirmButtonText: 'Enviar',
                })
              }

              return this.performVariousSalesAction({
                url: trigger.value,
                ...objectAlert,
                confirmButtonText: 'Enviar',
              })

            } else {
              this.defaultSettingsSwal()
              const swal = this.setupSwal()

              const previousStatus = []
              statusRequired.forEach(status => {
                const currentStatus = is.make('li', {}, [is.text(status)])
                previousStatus.push(currentStatus)
              })

              const html = is.make('ul', {}, previousStatus)

              swal.fire({
                icon: 'warning',
                title: 'Para realizar esta acción se debe haber cumplido alguno de los siguientes estados:',
                html,
                showCancelButton: false,
                showLoaderOnConfirm: false,
              })
            }
          }

          return response
        })
    },
    checkAndSendEmailPackageMIVI(url) {
      const objectForm = {
        estado: 'estado_mivi',
        estadoModelo: 'App\\Models\\EstadoMIVIPrecontratoCliente',
        transicion: 'paquete-enviado-mivi',
      }
      const form = this.objectToFormData(objectForm)

      axios.post(`/api/sale/formalities/${this.precontract.id}/verificar_si_estado_puede_cambiar`, form)
        .then(response => {
          if (response && response.data) {
            const { permited, statusRequired } = response.data

            if (permited) {
              this.sendEmailPackageMIVI(url)
            } else {
              this.defaultSettingsSwal()
              const swal = this.setupSwal()

              const previousStatus = []
              statusRequired.forEach(status => {
                const currentStatus = is.make('li', {}, [is.text(status)])
                previousStatus.push(currentStatus)
              })

              const html = is.make('ul', {}, previousStatus)

              swal.fire({
                icon: 'warning',
                title: 'Para realizar esta acción se debe haber cumplido alguno de los siguientes estados:',
                html,
                showCancelButton: false,
                showLoaderOnConfirm: false,
              })
            }
          }
        })
    },
    async handleSalesDinamicFileUpload(e, url, urlToRevert) {
      e.target.disabled = true

      const name = is.getUniqueAttribute(e.target, 'name')
      const fileId = is.getAttributeValue(e.target, 'archivoId')
      const datos = await this.asyncGetNaturalSizeImage(e.target.files)
      /** @var Promise */
      const NaturalData = this.getTheFirstWithout(datos)
      const { width, height } = await NaturalData
      const file = await this.asyncTakeCareOfCompressingOnly(e.target, width, height)
      const data = {}
      data[name] = file
      data['id'] = fileId

      this.captureDataForDinamicFileUpload(urlToRevert)

      const promise = axios.post(url, this.objectToFormData(data))
        .then(response => {
          e.target.disabled = false
          this.defaultSettingsToastSwal()
          this.swalTitle = this.$t('update_response')
          this.swalText = undefined
          this.positionedDialogToast()
          this.$store.dispatch('setUpdateStatus', this.generateRandomNumber(10))
          if (response.data && response.data.additionalDataToRevert) {
            this.$root.$emit('triggerSwitchRevertDataToast', true, response.data.additionalDataToRevert)
          }

          return response
        }).catch(error => {
          e.target.disabled = false

          return error
        })

      this.$refs.loadingComponent.load(promise)

      return promise
    },
    captureDataForDinamicFileUpload(urlToRevert) {
      const { id } = this.precontract
      const dataToRevert = [
        {
          id,
          relatedTables: [],
        },
      ]

      const message = 'Se actualizó documento.'

      this.captureDataToRevert('asign_sales', dataToRevert, message, urlToRevert)
    },
    verifyDinamicSaleImage(e, url, newVerifiedValue, revertActionUrl) {
      const name = is.getUniqueAttribute(e.target, 'name')
      const fileId = is.getAttributeValue(e.target, 'archivoId')
      const oldVerifiedValue = !newVerifiedValue

      const form = {}
      form[name] = newVerifiedValue
      form['archivo_id'] = fileId

      this.captureDataForVerifyDinamicImages(name, fileId, oldVerifiedValue, revertActionUrl)

      axios.post(url, this.objectToFormData(form))
        .then(response => {
          this.defaultSettingsToastSwal()
          this.swalTitle = this.$t('update_response')
          this.swalText = undefined
          this.positionedDialogToast()
          this.$root.$emit('triggerSwitchRevertDataToast', true)
          this.$store.dispatch('setUpdateStatus', this.generateRandomNumber(10))

          return response
        })
    },
    captureDataForVerifyDinamicImages(name, fileId, currentValue, urlToRevert) {
      const { id } = this.precontract
      const form = {}
      form[name] = currentValue
      form['archivo_id'] = fileId
      const message = 'Se actualizó información del Documento.'

      this.captureDataToRevert('update_sales', [{ id, information: form }], message, urlToRevert)
    },
    archiveDinamicSaleImage(e, url, urlToRevert) {
      this.defaultSettingsSwal()
      const swal = this.setupSwal()
      const name = is.getUniqueAttribute(e.currentTarget, 'name')
      const fileId = is.getAttributeValue(e.currentTarget, 'archivoId')

      swal.fire({
        title: this.$t('store'),
        text: this.$t('remove_text'),
        showCancelButton: true,
        preConfirm: () => {
          const data = {}
          data[`archivar_${name}`] = true
          data['archivo_id'] = fileId

          const form = this.objectToFormData(data)
          this.captureDataForArchiveDinamicImageFile(fileId, urlToRevert)

          return axios.post(url, form)
        },
      }).then(response => {
        if (this.checkVariable(response) && this.checkVariable(response.isConfirmed) && response.isConfirmed) {
          this.defaultSettingsToastSwal()
          this.swalTitle = this.$t('update_response')
          this.swalText = undefined
          this.positionedDialogToast()
          this.$root.$emit('triggerSwitchRevertDataToast', true)
          this.$store.dispatch('setUpdateStatus', this.generateRandomNumber(10))
        }
      })
    },
    captureDataForArchiveDinamicImageFile(fileId, url) {
      const { id } = this.precontract
      const dataToRevert = [
        {
          id,
          relatedTables: [
            {
              relation: 'archivosCedulaBeneficiarioMivi',
              action: 'restore',
              pivots: [
                {
                  id: fileId,
                },
              ],
            },
          ],
        },
      ]
      const message = 'Se actualizó información del Documento.'

      this.captureDataToRevert('asign_sales', dataToRevert, message, url)
    },
    sendSMSMessageToCostumer(url) {
      this.defaultSettingsSwal()
      const swal = this.setupSwal()

      return swal.fire({
        input: 'textarea',
        inputPlaceholder: 'Escriba el mensaje',
        inputAttributes: {
          'aria-label': 'Escribe su mensaje aquí',
        },
        showCancelButton: true,
        preConfirm: value => {
          const form = this.objectToFormData({ mensaje: value })

          return axios.post(url, form)
        },
      }).then(response => {
        if (this.checkVariable(response) && this.checkVariable(response.isConfirmed) && response.isConfirmed) {
          this.defaultSettingsToastSwal()
          this.swalTitle = this.$t('update_response')
          this.swalText = undefined
          this.positionedDialogToast()
          this.$store.dispatch('setUpdateStatus', this.generateRandomNumber(10))
        }

        return response
      })
    },
    changeHouseModelSales(url, currentProjectModelId, revertUrl) {
      this.defaultSettingsSwal()
      const swal = this.setupSwal()
      const promise = axios.get('/api/sale/project_models/list')
      promise.then(response => {
        const tem = []
        response.data.forEach(dato => {
          const { id, name } = dato
          tem[id] = name
        })

        return swal.fire({
          title: 'Seleccione un Modelo',
          input: 'select',
          inputPlaceholder: 'Seleccione de la lista',
          inputOptions: tem,
          showCancelButton: true,
          preConfirm: value => {
            const form = this.objectToFormData({ modelo_proyecto_id: value })
            const message = 'Se actualizó el modelo de casa.'
            const id = this.precontract.id
            this.captureDataToRevert('asign_sales', [{ id, columns: [{ column: 'modelo_proyecto_id', value: currentProjectModelId }] }], message, revertUrl)

            return axios.post(url, form)
          },
        }).then(response => {
          if (this.checkVariable(response) && this.checkVariable(response.isConfirmed) && response.isConfirmed) {
            this.defaultSettingsToastSwal()
            this.swalTitle = this.$t('project_model_assignment_response')
            this.swalText = undefined
            this.positionedDialogToast()
            this.$root.$emit('triggerSwitchRevertDataToast', true)
            this.$store.dispatch('setUpdateStatus', this.generateRandomNumber(10))
          }

          return response
        })
      })
    },
    assignProcessor(url, precontractId, currentProcessorId, reversionUrl, columnToRevertProcessorAssignment, action = 'asign_sales') {
      const selectedProcessorId  = this.selectedProcessor ? this.selectedProcessor.value : null

      if (selectedProcessorId && precontractId) {
        const form = this.objectToFormData({ tramitador_id: selectedProcessorId })
        const message = 'Se actualizó Tramitador del Cliente.'
        const dataToRevert = [
          {
            id: precontractId,
            columns: [
              {
                column: columnToRevertProcessorAssignment,
                value: currentProcessorId,
              },
            ],
          },
        ]
        this.captureDataToRevert(action, dataToRevert, message, reversionUrl)

        axios.post(url, form)
          .then(() => {
            this.defaultSettingsToastSwal()
            this.swalTitle = this.$t('answering_assignment_processor')
            this.swalText = undefined
            this.positionedDialogToast()
            this.$root.$emit('triggerSwitchRevertDataToast', true)
            this.$store.dispatch('setUpdateStatus', this.generateRandomNumber(10))
          })
      }
    },
    assignProcessorMassively(
      path,
      url,
      idsMarked,
      collection,
      indexColumn = 'id',
      columnToRevertProcessorAssignment,
      pathToRevert = null,
    ) {
      let form = this.createAdvancedFilter(path)
      if (this.isObject(form) && this.getAmountOfKeys(idsMarked) > 0) {
        const arrVal = []
        Object.keys(idsMarked).forEach(key => {
          if (this.checkVariable(idsMarked[key])) {
            arrVal.push(idsMarked[key])
          }
        })
        form['id_marked'] = arrVal
      }

      const selectedProcessorId  = this.selectedProcessor ? this.selectedProcessor.value : null

      if (selectedProcessorId) {
        form = this.objectToFormData({ ...form, tramitador_id: selectedProcessorId })

        pathToRevert = pathToRevert ? pathToRevert : path
        this.captureDataForMassivelyAssignSalesAgent(idsMarked, collection, indexColumn, pathToRevert, columnToRevertProcessorAssignment)

        axios.post(url, form)
          .then(() => {
            this.defaultSettingsToastSwal()
            this.swalTitle = this.$t('answering_assignment_processor')
            this.swalText = undefined
            this.positionedDialogToast()
            this.$root.$emit('triggerSwitchRevertDataToast', true)
            this.$store.dispatch('setUpdateStatus', this.generateRandomNumber(10))
          })
      }
    },
    assignProjectModelMassively(path, idsMarked, collection, indexColumn = 'id') {
      let form = this.createAdvancedFilter(path)
      if (this.isObject(form) && this.getAmountOfKeys(idsMarked) > 0) {
        const arrVal = []
        Object.keys(idsMarked).forEach(key => {
          if (this.checkVariable(idsMarked[key])) {
            arrVal.push(idsMarked[key])
          }
        })
        form['id_marked'] = arrVal
      }

      const { value } = this.selectedProjectModel

      if (value) {
        form = this.objectToFormData({ ...form, modelo_proyecto_id: value })
        this.captureDataForAssignModelMassivelySales(idsMarked, collection, indexColumn, path)

        axios.post(`${path}/asignar_masivamente_modelo_proyecto`, form)
          .then(() => {
            this.defaultSettingsToastSwal()
            this.swalTitle = this.$t('project_model_assignment_response')
            this.swalText = undefined
            this.positionedDialogToast()
            this.$root.$emit('triggerSwitchRevertDataToast', true)
            this.$store.dispatch('setUpdateStatus', this.generateRandomNumber(10))
          })
      }
    },
    assignProjectModel(url, reversionUrl) {
      const { value } = this.selectedProjectModel

      if (value) {
        const precontractId = this.precontract.id
        const form = this.objectToFormData({ modelo_proyecto_id: value })
        const columnsToRevert = [
          'modelo_proyecto_id',
          'precio_final',
          'gastos_legales_final',
          'gastos_tramites_final',
          'promocion_tramites_final',
          'lote_id',
          'estado_adenda_cliente_id',
          'fecha_estado_adenda_cliente',
          'precio_final_adenda',
          'financiamiento_monto',
          'estado_precontrato_id',
          'fecha_estado_precontrato',
        ]
        const columns = this.getColumnsAndValuesArrayToRevert(this.precontract, columnsToRevert)
        const message = 'Se actualizó el modelo de casa.'
        const dataToRevert = [{ id: precontractId, columns }]
        this.captureDataToRevert('asign_sales', dataToRevert, message, reversionUrl)

        axios.post(url, form)
          .then(() => {
            this.defaultSettingsToastSwal()
            this.swalTitle = this.$t('project_model_assignment_response')
            this.swalText = undefined
            this.positionedDialogToast()
            this.$root.$emit('triggerSwitchRevertDataToast', true)
            this.$store.dispatch('setUpdateStatus', this.generateRandomNumber(10))
          })
      }
    },
    attachPromiseOfSaleContract(url) {
      this.defaultSettingsSwal()
      const swal = this.setupSwal()
      const form = is.make('form', {}, [
        is.make('div', { 'class': 'form-group' }, [is.make('label', { 'for': 'contrato_promesa_compraventa_uri' }, [is.text('Adjunta el Contrato de Promesa Compra-Venta')]), is.make('input', { 'type': 'file', 'multiple': false, 'class': 'form-control', 'name': 'contrato_promesa_compraventa_uri', 'id': 'contrato_promesa_compraventa_uri' })]),
      ])

      return swal.fire({
        title: 'Contrato de Promesa Compra-Venta',
        text: 'Seleccione el archivo adjuntar. ',
        html: form,
        confirmButtonText: 'Adjuntar Contrato de Promesa Compra-Venta',
        showCancelButton: true,
        preConfirm: () => {
          const fileContractPromiseSale = is.nodeWith(form, '#contrato_promesa_compraventa_uri') ? is.getNodeWith(form, '#contrato_promesa_compraventa_uri').files[0] : null
          const newForm = this.objectToFormData({
            archivo_contrato_promesa_compraventa: fileContractPromiseSale,
          })

          return axios.post(url, newForm)
        },
      }).then(response => {
        if (this.checkVariable(response) && this.checkVariable(response.isConfirmed) && response.isConfirmed) {
          this.defaultSettingsToastSwal()
          this.swalTitle = this.$t('update_response')
          this.swalText = undefined
          this.positionedDialogToast()
          this.$store.dispatch('setUpdateStatus', this.generateRandomNumber(10))
        }

        return response
      })
    },
    attachMortgageApplication(url, bankId) {
      if (!this.determinesInspectionAction(['list'])) {
        return
      }

      const promise = axios.get('/api/bank_type/list')
      this.defaultSettingsSwal()
      const swal = this.setupSwal()

      return promise.then(response => {
        const { data } = response
        const banks = [{ '': '--SELECCIONAR--' }]
        const temBanks = this.getArrayValues(this.checkVariable(data) && this.isArray(data.data) ? data.data : [], 'id', 'nombre')
        const newBankId = this.checkVariable(bankId) ? bankId.toString() : ''
        const form = is.make('form', {}, [
          is.make('div', { 'class': 'form-group' }, [is.make('label', { 'for': 'banco_solicitud_bancaria_id' }, [is.text('Seleccione un banco')]), is.select(this.concat(banks, temBanks), { 'class': 'form-control', 'name': 'banco_solicitud_bancaria_id', 'id': 'banco_solicitud_bancaria_id' }, newBankId)]),
          is.make('div', { 'class': 'form-group' }, [is.make('label', { 'for': 'banco_solicitud_bancaria_uri' }, [is.text('Adjunte la Solicitud Hipotecaria')]), is.make('input', { 'type': 'file', 'multiple': false, 'class': 'form-control', 'name': 'banco_solicitud_bancaria_uri', 'id': 'banco_solicitud_bancaria_uri' })]),
        ])

        return swal.fire({
          title: 'Adjuntar Solicitud',
          text: 'Seleccione el banco al cual se realizó el proceso. ',
          html: form,
          confirmButtonText: 'Adjuntar solicitud bancaria',
          showCancelButton: true,
          preConfirm: () => {
            const bankId = is.nodeWith(form, '#banco_solicitud_bancaria_id') ? is.getNodeWith(form, '#banco_solicitud_bancaria_id').value : null
            const bankRequestFile = is.nodeWith(form, '#banco_solicitud_bancaria_uri') ? is.getNodeWith(form, '#banco_solicitud_bancaria_uri').files[0] : null
            const newForm = this.objectToFormData({
              banco_solicitud_bancaria_id: bankId,
              archivo_solicitud_bancaria: bankRequestFile,
            })

            return axios.post(url, newForm)
          },
        }).then(response => {
          if (this.checkVariable(response) && this.checkVariable(response.isConfirmed) && response.isConfirmed) {
            this.defaultSettingsToastSwal()
            this.swalTitle = this.$t('update_response')
            this.swalText = undefined
            this.positionedDialogToast()
            this.$store.dispatch('setUpdateStatus', this.generateRandomNumber(10))
          }

          return response
        })
      })
    },
    attachAPCVerificationRequest(url, bankId) {
      if (!this.determinesInspectionAction(['list'])) {
        return
      }

      const promise = axios.get('/api/bank_type/list')
      this.defaultSettingsSwal()
      const swal = this.setupSwal()

      return promise.then(response => {
        const { data } = response
        const banks = [{ '': '--SELECCIONAR--' }]
        const temBanks = this.getArrayValues(this.checkVariable(data) && this.isArray(data.data) ? data.data : [], 'id', 'nombre')
        const newBankId = this.checkVariable(bankId) ? bankId.toString() : ''
        const form = is.make('form', {}, [
          is.make('div', { 'class': 'form-group' }, [is.make('label', { 'for': 'banco_solicitud_bancaria_id' }, [is.text('Seleccione un banco')]), is.select(this.concat(banks, temBanks), { 'class': 'form-control', 'name': 'banco_solicitud_bancaria_id', 'id': 'banco_solicitud_bancaria_id' }, newBankId)]),
          is.make('div', { 'class': 'form-group' }, [is.make('label', { 'for': 'autorizacion_apc_uri' }, [is.text('Adjunta la Solicitud de Verificación de APC')]), is.make('input', { 'type': 'file', 'multiple': false, 'class': 'form-control', 'name': 'autorizacion_apc_uri', 'id': 'autorizacion_apc_uri' })]),
        ])

        return swal.fire({
          title: 'Adjuntar Solicitud',
          text: 'Seleccione el banco al cual se realizó el proceso. ',
          html: form,
          confirmButtonText: 'Adjunta la Solicitud de Verificación de APC',
          showCancelButton: true,
          preConfirm: () => {
            const bankId = is.nodeWith(form, '#banco_solicitud_bancaria_id') ? is.getNodeWith(form, '#banco_solicitud_bancaria_id').value : null
            const APCAutorizationFile = is.nodeWith(form, '#autorizacion_apc_uri') ? is.getNodeWith(form, '#autorizacion_apc_uri').files[0] : null
            const newForm = this.objectToFormData({
              banco_solicitud_bancaria_id: bankId,
              archivo_autorizacion_apc: APCAutorizationFile,
            })

            return axios.post(url, newForm)
          },
        }).then(response => {
          if (this.checkVariable(response) && this.checkVariable(response.isConfirmed) && response.isConfirmed) {
            this.defaultSettingsToastSwal()
            this.swalTitle = this.$t('update_response')
            this.swalText = undefined
            this.positionedDialogToast()
            this.$store.dispatch('setUpdateStatus', this.generateRandomNumber(10))
          }

          return response
        })
      })
    },
    attachInsurerBanks(url, bankId) {
      if (!this.determinesInspectionAction(['list'])) {
        return
      }

      const promise = axios.get('/api/bank_type/list')
      this.defaultSettingsSwal()
      const swal = this.setupSwal()

      return promise.then(response => {
        const { data } = response
        const banks = [{ '': '--SELECCIONAR--' }]
        const temBanks = this.getArrayValues(this.checkVariable(data) && this.isArray(data.data) ? data.data : [], 'id', 'nombre')
        const newBankId = this.checkVariable(bankId) ? bankId.toString() : ''
        const form = is.make('form', {}, [
          is.make('div', { 'class': 'form-group' }, [is.make('label', { 'for': 'banco_solicitud_bancaria_id' }, [is.text('Seleccione un banco')]), is.select(this.concat(banks, temBanks), { 'class': 'form-control', 'name': 'banco_solicitud_bancaria_id', 'id': 'banco_solicitud_bancaria_id' }, newBankId)]),
          is.make('div', { 'class': 'form-group' }, [is.make('label', { 'for': 'banco_aseguradora_uri' }, [is.text('Adjunta el Formulario propuesto Asegurado')]), is.make('input', { 'type': 'file', 'multiple': false, 'class': 'form-control', 'name': 'banco_aseguradora_uri', 'id': 'banco_aseguradora_uri' })]),
        ])

        return swal.fire({
          title: 'Adjuntar Solicitud',
          text: 'Seleccione el banco al cual se realizó el proceso. ',
          html: form,
          confirmButtonText: 'Adjunta el Formulario propuesto Asegurado',
          showCancelButton: true,
          preConfirm: () => {
            const bankId = is.nodeWith(form, '#banco_solicitud_bancaria_id') ? is.getNodeWith(form, '#banco_solicitud_bancaria_id').value : null
            const insuranceBankFile = is.nodeWith(form, '#banco_aseguradora_uri') ? is.getNodeWith(form, '#banco_aseguradora_uri').files[0] : null
            const newForm = this.objectToFormData({
              banco_solicitud_bancaria_id: bankId,
              archivo_aseguradora: insuranceBankFile,
            })

            return axios.post(url, newForm)
          },
        }).then(response => {
          if (this.checkVariable(response) && this.checkVariable(response.isConfirmed) && response.isConfirmed) {
            this.defaultSettingsToastSwal()
            this.swalTitle = this.$t('update_response')
            this.swalText = undefined
            this.positionedDialogToast()
            this.$store.dispatch('setUpdateStatus', this.generateRandomNumber(10))
          }

          return response
        })
      })
    },
    /**
     * @param {Object} data
     * @return {Array}
     */
    _validateHtmlElementsForBankFiles(data) {
      const _this = this
      let htmlContent = []
      Object.keys(data).forEach(key => {
        const value = _this.getObjectValue(data, key)
        if (_this.isObject(value) && _this.getBoolValue(_this.getObjectValue(value, 'visible')) === true) {
          const style = []
          if (_this.isObject(value.styles)) {
            for (let key in value.styles) {
              if (value.styles.hasOwnProperty(key)) {
                const val = _this.getObjectValue(value.styles, key)
                style.push(`${key}: ${val}`)
              }
            }
          }
          const tdA = is.make('td', { style }, [is.text(key)])
          htmlContent.push(tdA)
        } else if (_this.isObject(value)) {
          htmlContent.push(this._validateHtmlElementsForBankFiles(value))
        }
      })

      return htmlContent
    },
    /**
     * @param {Array} data
     * @return {HTMLElement}
     */
    _createSelectionTable(data) {
      const trs = []
      data.forEach(td => {
        const tr = is.make('tr', {}, [
          td,
          is.make('td', {}, [
            is.make('input', { 'type': 'checkbox', 'name': td.textContent, 'value': td.textContent }, []),
          ]),
        ])
        trs.push(tr)
      })
      const table = is.make('table', { 'class': 'excel-table-2007 fixed-width-table table-hover' }, [
        is.make('thead', { 'class': 'thead-light-blue' }, [
          is.make('tr', {}, [
            is.make('th', { 'class': 'text-center established-width' }, [is.text('Nombre')]),
            is.make('th', { 'class': 'text-center established-width' }, [is.text('Seleccionar')]),
          ]),
        ]),
        is.make('tbody', {}, [...trs]),
      ])

      return table
    },
    createExportBankDocumentsSales(url, id) {
      if (!this.determinesInspectionAction(['getDetailsOfBankDocuments'])) {
        return
      }

      const _this = this
      const promise = axios.get(`/api/sale/form/precontracts/${id}/details_of_bank_documents`)
      this.defaultSettingsSwal()
      const swal = this.setupSwal()

      return promise.then(response => {
        const { data } = response
        if (_this.checkVariable(data)) {
          /** @var {Object} personalInformation */
          const personalInformation = _this.getObjectValue(data, 'Datos Personales')
          // Eliminar datos personales del objeto principal
          is.unset(data, 'Datos Personales')
          /** @var {Array} personalDataRows */
          const personalDataRows = this._validateHtmlElementsForBankFiles(personalInformation)
          /** @var {Array} bankDetailsRows */
          const bankDetailsRows = this._validateHtmlElementsForBankFiles(data)
          /** @var {Array} bankData */
          const bankData = is.flatten(bankDetailsRows)
          /** @var {Array} personalData */
          const personalData = is.flatten(personalDataRows)
          /** @var {HTMLElement} table */
          const table = this._createSelectionTable(bankData)
          /** @var {HTMLElement} personalDataTable */
          const personalDataTable = this._createSelectionTable(personalData)
          const indications = is.make('div', { 'class': 'flex-container w-100' }, [
            is.make('div', { 'style': 'margin: 0 auto' }, [
              is.make('div', { style: 'width:20px;height:20px;background: #dcabab;margin: 0 auto' }, []),
              is.text('Archivos Adjuntos'),
            ]),
            is.make('div', { 'style': 'margin: 0 auto' }, [
              is.make('div', { style: 'width:20px;height:20px;background: #94f774;margin: 0 auto' }, []),
              is.text('Archivos Completo365'),
            ]),
          ])
          /** @var {HTMLElement} html */
          const html = is.make('div', {}, [indications, table, personalDataTable])

          return swal.fire({
            title: 'Unificar archivos',
            text: 'Seleccione de la lista el archivo a unificar.',
            html,
            confirmButtonText: 'Exportar',
            showCancelButton: true,
            preConfirm: () => {
              const inputs = is.checkAll(html)
              const values = []
              inputs.forEach(input => {
                values.push(input.value)
              })
              const hreff = is.createTheParametersOfTheUrl(values)

              return hreff
            },
          }).then(response => {
            if (_this.checkVariable(response) && _this.checkVariable(response.isConfirmed) && response.isConfirmed) {
              _this.defaultSettingsToastSwal()
              _this.swalTitle = _this.$t('update_response')
              _this.swalText = undefined
              _this.positionedDialogToast()

              window.open(`${url}${response.value}&token=${_this.authToken}`, '_blank')
            }

            return response
          })
        }

        return response
      })
    },
    attachOtherFiles(url) {
      this.defaultSettingsSwal()
      const swal = this.setupSwal()
      const content = is.make('div', {}, [
        is.make('label', { 'for': 'archivo_banco_otro_nombre' }, [
          is.text('Nombre'),
        ]),
        is.make('input', { 'type': 'text', 'name': 'archivo_banco_otro_nombre', 'id': 'archivo_banco_otro_nombre' }, []),
      ])
      const file = is.make('div', { 'class': 'form-group' }, [is.make('label', { 'for': 'archivo_banco_otro_uri' }, [is.text('Adjunta Otros Archivos Bancarios')]), is.make('input', { 'type': 'file', 'multiple': false, 'class': 'form-control', 'name': 'archivo_banco_otro_uri', 'id': 'archivo_banco_otro_uri' })])
      const form = is.make('div', {}, [content, file])

      return swal.fire({
        title: 'Adjuntar Otros Archivos',
        text: 'Seleccione y adjunta otros archivos bancarios.',
        html: form,
        showCancelButton: true,
        preConfirm: () => {
          const nameOtherBankFiles = is.nodeWith(form, '#archivo_banco_otro_nombre') ? is.getNodeWith(form, '#archivo_banco_otro_nombre').value : null
          const otherBankFiles = is.nodeWith(form, '#archivo_banco_otro_uri') ? is.getNodeWith(form, '#archivo_banco_otro_uri').files[0] : null
          const descripcion = is.checkVariable(otherBankFiles) ? JSON.stringify([{ name: otherBankFiles.name, value: is.checkVariable(nameOtherBankFiles) ? nameOtherBankFiles : 'Otro Archivo Bancario', visible: true }]) : null
          const data = this.objectToFormData({
            descripcion,
            archivo_banco_otro: otherBankFiles,
          })

          return axios.post(url, data)
        },
      }).then(response => {
        if (this.checkVariable(response) && this.checkVariable(response.isConfirmed) && response.isConfirmed) {
          this.defaultSettingsToastSwal()
          this.swalTitle = this.$t('update_response')
          this.swalText = undefined
          this.positionedDialogToast()
          this.$root.$emit('triggerSwitchRevertDataToast', true)
          this.$store.dispatch('setUpdateStatus', this.generateRandomNumber(10))
        }

        return response
      })
    },
    applyFileLibraryDocuments({ file, value }) {
      if (is.getAmountOfKeys(value) <= 0) {
        return
      }
      if (file) {
        const dataFile = is.dataURLtoFile(file.preview, file.name)
        const files = is.makeFileList([dataFile])
        let inputEvent = null
        let fileEvent = null
        const flattend = {}
        for (let obVal of value) {
          Object.assign(flattend, obVal)
        }
        const events = []
        Object.keys(flattend).forEach(name => {
          if (name === 'banco_solicitud_bancaria_id') {
            const selectElement = is.make('input', {
              type: 'input',
              name,
            })
            selectElement.value = is.getObjectValue(flattend, name)
            inputEvent = is.createEvent('input', selectElement, {})
            events.push(inputEvent)
          } else {
            const tmName = is.getObjectValue(flattend, name)
            const fileBin = is.make('input', {
              type: 'file',
              name: tmName,
            })
            fileBin.files = files
            fileEvent = is.createEvent('input', fileBin, {})
            events.push(fileEvent)
          }
        })
        let maxCatidadVeces = 0
        const _this = this
        if (timeCargaArchivo !== null) {
          clearInterval(timeCargaArchivo)
        }
        const promise = new Promise ((resolve, reject) => {
          timeCargaArchivo = setInterval(
            (archivos) => {
              if (archivos && events.length > 0) {
                resolve(archivos)
              }
              if (maxCatidadVeces > 100) {
                reject([])
              }
              maxCatidadVeces++
            },
            500,
            events,
          )
        })
        promise.then(() => {
          _this.handleFileUpload(events)
          _this.updateAssignedStatusFile(events, file)
          clearInterval(timeCargaArchivo)
        }).catch(() => {
          clearInterval(timeCargaArchivo)
        })
      }
    },
    changeStatusToAnyOther(url, statusNameId) {
      this.defaultSettingsSwal()
      const swal = this.setupSwal()

      return swal.fire({
        input: 'textarea',
        inputPlaceholder: 'Agrega un comentario',
        inputAttributes: {
          'aria-label': 'Escribe tu mensaje aquí',
        },
        showCancelButton: true,
        preConfirm: value => {
          const form = this.objectToFormData({ descripcion: value, status_name_id: statusNameId })

          return axios.post(url, form)
        },
      }).then(response => {
        if (this.checkVariable(response) && this.checkVariable(response.isConfirmed) && response.isConfirmed) {
          this.defaultSettingsToastSwal()
          this.swalTitle = this.$t('update_response')
          this.swalText = undefined
          this.positionedDialogToast()
          this.$store.dispatch('setUpdateStatus', this.generateRandomNumber(10))
        }

        return response
      })
    },
    alertCellphoneAlreadyExists() {
      this.defaultSettingsSwal()
      const swal = this.setupSwal()

      swal.fire({
        title: this.$t('cellphone_already_exists_do_you_want_to_replace_it'),
        icon: 'warning',
        showCancelButton: true,
        showLoaderOnConfirm: false,
      }).then(response => {
        if (response && response.isConfirmed) {
          this.update()
        }
      })
    },
    async verifyCellphoneAndUpdateSale(url) {
      const data = this.objectToFormData({ celular: this.editForm.celular })

      axios.post(url, data)
        .then(response => {
          if (response && response.data && typeof response.data.cellphoneExists === 'boolean') {
            const cellphoneExists = response.data.cellphoneExists

            if (cellphoneExists) {
              this.alertCellphoneAlreadyExists()
            } else {
              this.update()
            }
          }
        })
    },
    checkForSendMinuteMailProcedure(url) {
      if (
        !this.checkVariable(this.precontract.archivo_minuta_hipotecario_uri)
        || !this.checkVariable(this.precontract.archivo_minuta_interino_uri)
      ) {
        this.defaultSettingsSwal()
        const swal = this.setupSwal()

        let text = 'Hace(n) falta la(s) siguiente(s) minuta(s): '

        if (!this.checkVariable(this.precontract.archivo_minuta_hipotecario_uri)) {
          text += '"Minuta de Banco Hipotecario",'
        }
        if (!this.checkVariable(this.precontract.archivo_minuta_interino_uri)) {
          text += '"Minuta de Banco Interino"'
        }

        text += '. ¿Desea enviar este correo de todas formas?'

        return swal.fire({
          icon: 'warning',
          title: this.$t('warning'),
          text,
          showCancelButton: true,
          showLoaderOnConfirm: false,
        }).then(response => {
          if (this.checkVariable(response) && this.checkVariable(response.isConfirmed) && response.isConfirmed) {
            this.sendMinuteMailProcedure(url)
          }
        })
      }

      this.sendMinuteMailProcedure(url)
    },
    saveHouseHandoverDateAndPersonSale(urlToSaveData, urlToGenerateDocument) {
      return this.houseHandoverDataForm.post(urlToSaveData)
        .then(response => {
          this.hideHouseHandoverDataModal()
          this.defaultSettingsToastSwal()
          this.swalTitle = this.$t('update_response')
          this.swalText = undefined
          this.positionedDialogToast()
          this.$store.dispatch('setUpdateStatus', this.generateRandomNumber(10))

          window.open(urlToGenerateDocument, '_blank')

          return response
        })
    },
    mergeFilesInPDFSales(url, filesIds) {
      const filesIdsJson = JSON.stringify(filesIds)
      const data = this.objectToFormData({ filesIds: filesIdsJson })

      return axios.post(url, data)
        .then(response => {
          if (response && response.data) {
            this.defaultSettingsToastSwal()
            this.swalTitle = this.$t('update_response')
            this.swalText = undefined
            this.positionedDialogToast()
            this.$store.dispatch('setUpdateStatus', this.generateRandomNumber(10))
            this.highlightFileWrapper(response.data.id)
          }
        })
    },
    confirmSendToBankSales(url) {
      this.defaultSettingsSwal()
      const swal = this.setupSwal()

      swal.fire({
        title: '¿Listo para enviar a banco?',
        confirmButtonText: 'Marcar',
        showCancelButton: true,
        showConfirmButton: true,
        preConfirm: () => {
          this.captureDataForStateChangeReadyToSend()

          return axios.post(url, {})
        },
      }).then(response => {
        if (this.checkVariable(response) && this.checkVariable(response.isConfirmed) && response.isConfirmed) {
          this.defaultSettingsToastSwal()
          this.swalTitle = this.$t('update_response')
          this.swalText = undefined
          this.positionedDialogToast()
          this.$root.$emit('triggerSwitchRevertDataToast', true)
          this.$store.dispatch('setUpdateStatus', this.generateRandomNumber(10))
        }

        return response
      })
    },
    makeAssignedFileMark(events, url, file) {
      let names = []
      if (this.isArray(events)) {
        events.forEach((event) => {
          const element = event.target
          names.push({ name: element.name })
        })
      }
      const promise = axios.post(url, {...names, id: this.getObjectValue(file, 'id')})
        .then(response => {
          this.defaultSettingsToastSwal()
          this.swalTitle = this.$t('update_response')
          this.swalText = undefined
          this.positionedDialogToast()
          this.$root.$emit('triggerSwitchRevertDataToast', true)
          this.$store.dispatch('setUpdateStatus', this.generateRandomNumber(10))

          return response
        }).catch(error => {
          return error
        })

      if (this.$refs.loadingComponent && this.$refs.loadingComponent.load) {
        this.$refs.loadingComponent.load(promise)
      }

      return promise
    },
    captureDataDeleteLibraryFileSales(file, urlToRevert) {
      const {id} = this.precontract
      const message = 'Se ocultó el archivo de la biblioteca.'

      this.captureDataToRevert(
        'asign_sales', [
          {
            id,
            relatedTables: [
              {
                relation: 'archivos_precontratocliente',
                action: 'update',
                pivots: [
                  {
                    id: file.id,
                    columns: { 'visible': file.visible },
                  },
                ],
              },
            ],
          },
        ],
        message,
        urlToRevert,
      )
    },
    captureDataRestoreLibraryFileSales(file, urlToRevert) {
      const {id} = this.precontract
      const message = 'Se Restauró el archivo de la biblioteca.'

      this.captureDataToRevert(
        'asign_sales', [
          {
            id,
            relatedTables: [
              {
                relation: 'archivos_precontratocliente',
                action: 'update',
                pivots: [
                  {
                    id: file.id,
                    columns: { 'visible': file.visible },
                  },
                ],
              },
            ],
          },
        ],
        message,
        urlToRevert,
      )
    },
    captureDataRestoreHideLibraryFileSales(filesIds, urlToRevert) {
      const message = 'Se ocultó el archivo de la biblioteca.'

      this.captureDataToRevert(
        'asign_sales', [
          {
            id: this.idModel,
            relatedTables: [
              {
                relation: 'archivos_precontratocliente',
                action: 'update',
                pivots: [
                  {
                    id: filesIds,
                    columns: { 'visible': true },
                  },
                ],
              },
            ],
          },
        ],
        message,
        urlToRevert,
      )
    },
    deleteLibraryFileSales(url, file, urlToRevert) {
      this.defaultSettingsSwal()
      const swal = this.setupSwal()

      return swal.fire({
        title: '¿Se ocultará el archivo de la biblioteca?',
        confirmButtonText: 'Marcar',
        showCancelButton: true,
        showConfirmButton: true,
        preConfirm: () => {
          this.captureDataDeleteLibraryFileSales(file, urlToRevert)

          return axios.post(url, {id: this.getObjectValue(file, 'id')})
        },
      }).then(response => {
        if (this.checkVariable(response) && this.checkVariable(response.isConfirmed) && response.isConfirmed) {
          this.defaultSettingsToastSwal()
          this.swalTitle = this.$t('update_response')
          this.swalText = undefined
          this.positionedDialogToast()
          this.$root.$emit('triggerSwitchRevertDataToast', true)
          this.$store.dispatch('setUpdateStatus', this.generateRandomNumber(10))
        }

        return response
      })
    },
    fillGlobalTotalColumnsSales() {
      this.localGlobalTotalColumns = [
        { key: 'global_total_final_price', text: this.$t('total_house_prices'), column: 'total_precio_viviendas' },
      ]
    },
    restoreLibraryFileSales(url, file, urlToRevert) {
      this.defaultSettingsSwal()
      const swal = this.setupSwal()

      return swal.fire({
        title: '¿Se restaurará el archivo de la biblioteca?',
        confirmButtonText: 'Marcar',
        showCancelButton: true,
        showConfirmButton: true,
        preConfirm: () => {
          this.captureDataRestoreLibraryFileSales(file, urlToRevert)

          return axios.post(url, {id: this.getObjectValue(file, 'id')})
        },
      }).then(response => {
        if (this.checkVariable(response) && this.checkVariable(response.isConfirmed) && response.isConfirmed) {
          this.defaultSettingsToastSwal()
          this.swalTitle = this.$t('update_response')
          this.swalText = undefined
          this.positionedDialogToast()
          this.$root.$emit('triggerSwitchRevertDataToast', true)
          this.$store.dispatch('setUpdateStatus', this.generateRandomNumber(10))
        }

        return response
      })
    },
    hideSelectedFilesSales(url, filesIds, urlToRevert) {
      this.defaultSettingsSwal()
      const swal = this.setupSwal()

      return swal.fire({
        title: '¿Se ocultará los archivos de la biblioteca?',
        confirmButtonText: 'Marcar',
        showCancelButton: true,
        showConfirmButton: true,
        preConfirm: () => {
          this.captureDataRestoreHideLibraryFileSales(filesIds, urlToRevert)

          const data = this.objectToFormData({ filesIds })

          return axios.post(url, data)
        },
      }).then(response => {
        if (this.checkVariable(response) && this.checkVariable(response.isConfirmed) && response.isConfirmed) {
          this.defaultSettingsToastSwal()
          this.swalTitle = this.$t('update_response')
          this.swalText = undefined
          this.positionedDialogToast()
          this.$root.$emit('triggerSwitchRevertDataToast', true)
          this.$store.dispatch('setUpdateStatus', this.generateRandomNumber(10))
        }

        return response
      })
    },
    captureDataRemoveFromMyFamilyGroup(form, urlToRevert) {
      const {id} = this.precontract
      const message = 'Se procedió a marcar el registro para recuperar eliminar.'

      this.captureDataToRevert(
        'recuperar_mi_grupo_familiar', [
          {
            id,
            relatedTables: [
              {
                relation: 'miGrupoFamiliar',
                action: 'restore',
                columns: [{ 'column': 'cedula', 'value': form.cedula }],
              },
            ],
          },
        ],
        message,
        urlToRevert,
      )
    },
    confirmRemoveFromMyFamilyGroup(url, form, urlToRevert) {
      this.defaultSettingsSwal()
      const swal = this.setupSwal()

      swal.fire({
        title: '¿Listo para eliminar de tu grupo?',
        confirmButtonText: 'Eliminar',
        showCancelButton: true,
        showConfirmButton: true,
        preConfirm: () => {
          this.captureDataRemoveFromMyFamilyGroup(form, urlToRevert)

          return form.post(url)
        },
      }).then(response => {
        if (this.checkVariable(response) && this.checkVariable(response.isConfirmed) && response.isConfirmed) {
          this.defaultSettingsToastSwal()
          this.swalTitle = this.$t('update_response')
          this.swalText = undefined
          this.positionedDialogToast()
          this.$root.$emit('triggerSwitchRevertDataToast', true)
          this.$store.dispatch('setUpdateStatus', this.generateRandomNumber(10))
        }

        return response
      })
    },
    deleteConversation(model, url, indexColumn = 'id', alternativeUrl = null, otherText = null) {
      const promise = this.actionDeleteFile(url, model[indexColumn], 'delete_conversations', alternativeUrl, otherText)
      this.actionDeleteThen(promise)
    },
    getColorAccordingToText(textColor) {
      let color = '#Ff0000'
      switch (textColor) {
        case 'verde':
          color = '#4abe25'
          break
        case 'amarillo':
          color = '#Fffd00'
          break
        case 'rojo':
          color = '#Ff0000'
          break
      }

      return color
    },
    updateMessageSentByClient(room=null) {
      if (this.checkVariable(room) && room.unreadCount > 0) {
        this.$store.dispatch('changeStatusToReadByTheProcessor', room)
      }
    },
    messageActionHandler({roomId, action, message}) {
      this.defaultSettingsSwal()
      const swal = this.setupSwal()
      const html = is.make('div', {
        'class': 'form-group',
      }, [
        is.make('label', { 'for': 'selecciona_destino_archivo_conversacion' }, [is.text('Selecciona donde aplicar *')]),
        is.select([
          { archivo_firma_biblioteca: 'Firma' },
          { archivo_cedula_biblioteca: 'Cédula/Pasaporte' },
          { archivo_cedula_reverso_biblioteca: 'Cédula/Pasaporte (reverso)' },
          { archivo_ficha_biblioteca: 'Ficha' },
          { archivo_talonario_biblioteca: 'Talonario' },
          { archivo_carta_trabajo_biblioteca: 'Carta de Trabajo' },
          { archivo_recibo_biblioteca: 'Recibo (Agua/Luz/Internet/Telefonía)' },
          { archivo_autorizacion_verificacion_apc_la_hipotecaria_biblioteca: 'Autorización De Consulta APC' },
          { archivo_contrato_promesa_compraventa: 'Contrato de Promesa Compra-Venta' },
        ], {
          'class': 'form-control',
          'name': 'selecciona_destino_archivo_conversacion',
        }),
      ])
      listen(html, 'change', e => {
        const value = e.target.value || null
        if (
          this.determinesInspectionAction(['list']) &&
          [
            'archivo_autorizacion_verificacion_apc_la_hipotecaria_biblioteca',
          ].indexOf(value) !== -1
        ) {
          axios.get('/api/bank_type/list').then(response => {
            const { data } = response
            const banks = [{ '': '--SELECCIONAR--' }]
            const temBanks = this.getArrayValues(this.checkVariable(data) && this.isArray(data.data) ? data.data : [], 'id', 'nombre')
            const newBankId = this.checkVariable(this.bankId) ? this.bankId.toString() : ''
            html.append(is.make('div', { 'class': 'form-group' }, [is.make('label', { 'for': 'banco_solicitud_bancaria_id' }, [is.text('Seleccione un banco *')]), is.select(this.concat(banks, temBanks), { 'class': 'form-control', 'name': 'banco_solicitud_bancaria_id', 'id': 'banco_solicitud_bancaria_id' }, newBankId)]))
          })
        }
      })
      swal.fire({
        title: '¿Confirme para designar?',
        html,
        showConfirmButton: true,
        preConfirm: () => {
          const value = is.getFormInputValues(html)

          return value
        },
      }).then(response => {
        if (this.checkVariable(response) && this.checkVariable(response.isConfirmed) && response.isConfirmed) {
          this.defaultSettingsToastSwal()
          this.swalTitle = this.$t('update_response')
          this.swalText = undefined
          this.positionedDialogToast()
          this.$store.dispatch('assignFileToClient', { roomId, action, message, value: response.value })
        }

        return response
      })
    },
  },
}

const Component = Vue.extend({
  name: 'new-helper-sale',
  mixins: [helperMixin],
})

export default Component
